/* ============================================
   VAPOR MALL — Main Game Engine v3
   3-floor world builder. Each floor reads
   config from its Shopify section data.
   ============================================ */

(function () {
  'use strict';

  var CONFIG = window.VAPOR_MALL;
  var T = VaporSprites.TILE;
  var FLOOR_W = 50;
  var FLOOR_H = 40;

  // ---- Floor music controller (single <audio> element, cycles through a per-floor playlist) ----
  var MusicController = (function () {
    var audio = null;
    var tracks = [];      // [{url, name}, ...] — non-empty urls only
    var idx = 0;
    var muted = localStorage.getItem('vapor-mall-music-muted') === '1';
    var tickerTimer = null;
    var tickerHideTimer = null;
    var TICKER_INTERVAL_MS = 35000;
    var TICKER_SHOW_MS = 15000;

    function ensureEl() {
      if (audio) return audio;
      audio = document.getElementById('vapor-mall-music');
      if (!audio) {
        audio = document.createElement('audio');
        audio.id = 'vapor-mall-music';
        audio.preload = 'auto';
        audio.style.display = 'none';
        document.body.appendChild(audio);
      }
      // Playlist cycling — not loop=true at element level. Handled by 'ended' below.
      audio.loop = false;
      audio.volume = 0.55;
      audio.muted = muted;
      // Wire 'ended' once — advance to next track
      if (!audio._mcEndedBound) {
        audio._mcEndedBound = true;
        audio.addEventListener('ended', function () {
          if (tracks.length === 0) return;
          idx = (idx + 1) % tracks.length;
          _loadCurrent(true);
          _showTickerOnce();
        });
      }
      return audio;
    }

    function tryPlay() {
      var el = ensureEl();
      if (!el.src) return;
      var p = el.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* autoplay blocked — wait for user gesture */ });
      }
    }

    function _loadCurrent(autoplay) {
      var el = ensureEl();
      if (tracks.length === 0) { el.pause(); el.removeAttribute('src'); el.load(); return; }
      var t = tracks[idx] || tracks[0];
      if (!t || !t.url) return;
      el.src = t.url;
      el.currentTime = 0;
      if (autoplay !== false) tryPlay();
    }

    function setPlaylist(newTracks) {
      // Filter + dedupe-by-url
      var cleaned = (newTracks || []).filter(function (t) { return t && t.url; });
      // If unchanged, just keep playing
      var same = cleaned.length === tracks.length && cleaned.every(function (t, i) {
        return tracks[i] && tracks[i].url === t.url;
      });
      if (same) { tryPlay(); return; }
      tracks = cleaned;
      idx = 0;
      _stopTicker();
      _loadCurrent(true);
      if (tracks.length > 0) {
        // Show ticker shortly after load, then repeat periodically
        setTimeout(_showTickerOnce, 1500);
        tickerTimer = setInterval(_showTickerOnce, TICKER_INTERVAL_MS);
      }
    }

    function setMuted(m) {
      muted = !!m;
      localStorage.setItem('vapor-mall-music-muted', muted ? '1' : '0');
      if (audio) audio.muted = muted;
      var btn = document.getElementById('hud-mute-btn');
      if (btn) btn.classList.toggle('hud__mute-btn--muted', muted);
    }

    function isMuted() { return muted; }

    // Unlock autoplay on first user interaction (browsers block audio.play until then)
    function armUnlock() {
      var once = function () {
        tryPlay();
        document.removeEventListener('pointerdown', once, true);
        document.removeEventListener('keydown', once, true);
        document.removeEventListener('touchstart', once, true);
      };
      document.addEventListener('pointerdown', once, true);
      document.addEventListener('keydown', once, true);
      document.addEventListener('touchstart', once, true);
    }

    // ---- Now-playing ticker ----
    function _tickerEl() { return document.getElementById('hud-now-playing'); }

    function _stopTicker() {
      if (tickerTimer) { clearInterval(tickerTimer); tickerTimer = null; }
      if (tickerHideTimer) { clearTimeout(tickerHideTimer); tickerHideTimer = null; }
      var el = _tickerEl();
      if (el) el.classList.remove('hud__now-playing--visible');
    }

    function _currentName() {
      var t = tracks[idx];
      return (t && t.name) ? t.name : '';
    }

    function _showTickerOnce() {
      var el = _tickerEl();
      var name = _currentName();
      if (!el || !name) return;
      el.textContent = name;
      el.classList.add('hud__now-playing--visible');
      if (tickerHideTimer) clearTimeout(tickerHideTimer);
      tickerHideTimer = setTimeout(function () {
        if (el) el.classList.remove('hud__now-playing--visible');
      }, TICKER_SHOW_MS);
    }

    return { setPlaylist: setPlaylist, setMuted: setMuted, isMuted: isMuted, tryPlay: tryPlay, armUnlock: armUnlock };
  })();
  window.VaporMallMusic = MusicController;

  // Store positions on each floor
  // facing: which side of the block faces the mall center ('bottom' row or 'top' row)
  var POSITION_MAP = {
    'top-left':     { x: 3,  y: 3,  w: 10, h: 7, doorX: 8,  doorY: 10, facing: 'bottom' },
    'top-right':    { x: 37, y: 3,  w: 10, h: 7, doorX: 42, doorY: 10, facing: 'bottom' },
    'bottom-left':  { x: 3,  y: 28, w: 10, h: 7, doorX: 8,  doorY: 27, facing: 'top' },
    'bottom-right': { x: 37, y: 28, w: 10, h: 7, doorX: 42, doorY: 27, facing: 'top' }
  };

  // Kiosk positions — top/bottom are wide rectangles (9 wide, centered), sides are square
  // facing: which side faces mall center ('bottom' = prompt/sign below, 'top' = above)
  var KIOSK_POSITION_MAP = {
    'top-center':    { x: 20.5, y: 4,  w: 9, h: 3, facing: 'bottom' },
    'left-middle':   { x: 6,    y: 17, w: 4, h: 4, facing: 'right' },
    'right-middle':  { x: 40,   y: 17, w: 4, h: 4, facing: 'left' },
    'bottom-center': { x: 20.5, y: 35, w: 9, h: 3, facing: 'top' }
  };

  // Map kiosk block types to their positions
  var KIOSK_TYPE_TO_POSITION = {
    'kiosk_top': 'top-center',
    'kiosk_bottom': 'bottom-center',
    'kiosk_left': 'left-middle',
    'kiosk_right': 'right-middle'
  };

  var ESCALATOR_UP   = { x: 22, y: 10, w: 2, h: 3 };
  var ESCALATOR_DOWN = { x: 26, y: 10, w: 2, h: 3 };
  // Secret basement door — bottom-left quadrant of Floor 1, cut into the bottom wall
  var BASEMENT_DOOR  = { x: 14, y: 37, w: 2, h: 2 };
  // Basement return-stairs — center-top of Basement floor
  var BASEMENT_RETURN = { x: 24, y: 10, w: 2, h: 3 };

  // Parse comma-separated hex colors from a setting, falling back to defaults
  function parsePalette(str, defaults) {
    if (!str) return defaults;
    var colors = str.split(/[,\s]+/).map(function (s) { return s.trim(); }).filter(function (s) { return /^#?[0-9a-f]{3,8}$/i.test(s); });
    if (!colors.length) return defaults;
    return colors.map(function (c) { return c.startsWith('#') ? c : '#' + c; });
  }

  function getAvatarPalette(which) {
    var defaults = {
      skin: ['#f5c6a0', '#e0ac84', '#c68642', '#8d5524', '#6b3a1f', '#f9dcc4'],
      shirt: ['#ff71ce', '#01cdfe', '#b967ff', '#05ffa1', '#fffb96', '#ff4444', '#ffffff', '#1a1a2e'],
      hair: ['#1a1a2e', '#4a3728', '#8b6914', '#d4a030', '#c0392b', '#ff71ce', '#01cdfe', '#b967ff', '#ffffff']
    };
    return parsePalette((CONFIG.avatarPalette && CONFIG.avatarPalette[which]) || '', defaults[which]);
  }

  // ---- Helper: register sprite frames ----
  function registerSpriteFrames(scene, texKey) {
    var tex = scene.textures.get(texKey);
    var SW = VaporSprites.SPRITE_W * 2;
    var SH = VaporSprites.SPRITE_H * 2;
    for (var row = 0; row < 4; row++)
      for (var frame = 0; frame < 4; frame++)
        tex.add(row * 4 + frame, 0, frame * SW, row * SH, SW, SH);
  }

  // Read floor data from JSON blobs rendered by each floor section
  function loadFloorData() {
    CONFIG.floors = [];
    for (var i = 1; i <= 5; i++) {
      var el = document.querySelector('[data-vapor-floor="' + i + '"]');
      if (el) {
        try {
          var data = JSON.parse(el.textContent);
          CONFIG.floors.push(data);
        } catch (e) {
          console.error('Failed to parse floor ' + i + ' data:', e);
        }
      }
    }
    var basementEl = document.querySelector('[data-vapor-floor="Basement"]');
    if (basementEl) {
      try { CONFIG.floors.push(JSON.parse(basementEl.textContent)); }
      catch (e) { console.error('Failed to parse basement data:', e); }
    }
    console.log('VAPOR MALL FLOORS:', JSON.stringify(CONFIG.floors));
    console.log('Floor count:', CONFIG.floors.length);
    CONFIG.floors.forEach(function(f) {
      console.log('Floor ' + f.floor + ': visible=' + f.visible + ', stores=' + (f.stores ? f.stores.length : 0));
    });
  }

  function getFloor(n) {
    return CONFIG.floors.find(function (f) { return f.floor === n; });
  }

  function isFloorVisible(n) {
    var f = getFloor(n);
    return f && f.visible !== false;
  }

  // ---- DOM Chat Bubbles ----
  var chatBubbleContainer = null;
  var activeBubbles = [];

  function initChatBubbles() {
    if (chatBubbleContainer) return;
    chatBubbleContainer = document.createElement('div');
    chatBubbleContainer.id = 'chat-bubbles';
    chatBubbleContainer.style.cssText = 'position:fixed;inset:0;z-index:90;pointer-events:none;overflow:hidden;';
    document.body.appendChild(chatBubbleContainer);
  }

  function showBubble(scene, sprite, text) {
    initChatBubbles();
    var el = document.createElement('div');
    el.className = 'chat-bubble-dom';
    el.textContent = text;
    chatBubbleContainer.appendChild(el);
    var entry = { el: el, sprite: sprite, scene: scene };
    activeBubbles.push(entry);
    setTimeout(function () {
      el.classList.add('chat-bubble-dom--fade');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
        activeBubbles = activeBubbles.filter(function (b) { return b.el !== el; });
      }, 600);
    }, 5000);
  }

  function updateBubbles() {
    // Compute the game container offset once per frame (mobile: game is below
    // the top frame; bubbles are body-level fixed elements so they need this offset)
    var gameDiv = document.getElementById('vapor-mall-game');
    var rect = gameDiv ? gameDiv.getBoundingClientRect() : { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
    activeBubbles.forEach(function (b) {
      if (!b.sprite || !b.sprite.active) return;
      var cam = b.scene.cameras.main;
      var pt = cam.getWorldPoint(0, 0);
      // Anchor the bubble above the sprite head; offset scales with zoom so it
      // stays visually attached at any zoom level (was 34px in world space —
      // when zoom < 1 that became more world tiles above the head than expected)
      var headOffsetPx = 34 * cam.zoom;
      var sx = rect.left + (b.sprite.x - pt.x) * cam.zoom;
      var sy = rect.top + (b.sprite.y - pt.y) * cam.zoom - headOffsetPx;
      b.el.style.left = sx + 'px';
      b.el.style.top = sy + 'px';
      b.el.style.display = (sx < -100 || sx > window.innerWidth + 100 || sy < -50 || sy > window.innerHeight + 50) ? 'none' : '';
    });
  }

  function clearBubbles() {
    activeBubbles.forEach(function (b) { if (b.el.parentNode) b.el.parentNode.removeChild(b.el); });
    activeBubbles = [];
  }

  // ---- Default center element for each element set (used when "auto" is selected) ----
  var SET_DEFAULT_CENTER = {
    'vaporwave-oasis': 'fountain',
    'cyber-lounge': 'skylight',
    'zen-garden': 'sand-circle',
    'retro-diner': 'diner-counter',
    'crystal-cave': 'crystal-cluster',
    'neon-jungle': 'plant-cluster'
  };

  // ---- Center Element Renderers — all sized for a 5×4 tile footprint ----
  var CENTER_ELEMENTS = {
    'fountain': function (scene, cx, cy, addWall) {
      var fountain = scene.add.image(cx, cy, 'fountain').setDepth(2);
      fountain.setDisplaySize(T * 5, T * 4);
      addWall(cx - T * 2.5, cy - T * 2, T * 5, T * 4);
      scene.tweens.add({ targets: fountain, alpha: { from: 0.9, to: 1 }, duration: 800, yoyo: true, repeat: -1 });
    },
    'skylight': function (scene, cx, cy, addWall) {
      var sky = scene.add.ellipse(cx, cy, T * 5, T * 4, 0x01cdfe, 0.08).setDepth(0);
      scene.tweens.add({ targets: sky, alpha: { from: 0.04, to: 0.12 }, duration: 3000, yoyo: true, repeat: -1 });
      scene.add.rectangle(cx, cy, T * 5, T * 4, 0x8888aa, 0).setStrokeStyle(2, 0x8888aa).setDepth(1);
      // No collision — it's a ceiling opening
    },
    'sand-circle': function (scene, cx, cy, addWall) {
      for (var r = 3; r > 0; r--) {
        scene.add.ellipse(cx, cy, T * r * 1.8, T * r * 1.4, 0xd4c5b0, 0.06).setDepth(0);
        scene.add.ellipse(cx, cy, T * r * 1.8, T * r * 1.4, 0x000000, 0).setStrokeStyle(1, 0xd4c5b0, 0.15).setDepth(0);
      }
      scene.add.ellipse(cx, cy, T * 2, T * 1.3, 0x5a5a6a, 0.7).setDepth(2);
      scene.add.ellipse(cx - 3, cy - 3, T * 1.7, T * 1.1, 0x6a6a7a, 0.5).setDepth(2);
      addWall(cx - T * 2.5, cy - T * 2, T * 5, T * 4);
    },
    'diner-counter': function (scene, cx, cy, addWall) {
      scene.add.rectangle(cx, cy, T * 5, T * 2, 0x8a3030, 0.8).setDepth(2);
      scene.add.rectangle(cx, cy - T * 0.5, T * 4.5, T * 0.4, 0xd4a030, 0.5).setDepth(3);
      addWall(cx - T * 2.5, cy - T, T * 5, T * 2);
      for (var bs = -2; bs <= 2; bs++) {
        scene.add.circle(cx + bs * T, cy + T * 1.5, 7, 0xc0c0c0, 0.6).setDepth(2);
      }
    },
    'crystal-cluster': function (scene, cx, cy, addWall) {
      var colors = [0x01cdfe, 0xb967ff, 0xff71ce, 0x05ffa1];
      for (var i = 0; i < 7; i++) {
        var col = colors[i % 4];
        var ox = (i - 3) * 16, oy = (i % 2 === 0) ? -12 : 8;
        var h = T * (1.5 + Math.random() * 1.2);
        scene.add.triangle(cx + ox, cy + oy, 0, h, h * 0.4, 0, h * 0.8, h, col, 0.5).setDepth(2);
        var glow = scene.add.circle(cx + ox + h * 0.2, cy + oy, h, col, 0.1).setDepth(1);
        scene.tweens.add({ targets: glow, alpha: { from: 0.05, to: 0.15 }, duration: 1500 + Math.random() * 2000, yoyo: true, repeat: -1 });
      }
      addWall(cx - T * 2.5, cy - T * 2, T * 5, T * 4);
    },
    'plant-cluster': function (scene, cx, cy, addWall) {
      var greens = [0x0a6b3d, 0x0d8a4e, 0x10a85f];
      for (var p = 0; p < 10; p++) {
        var ox = (Math.random() - 0.5) * T * 4.5;
        var oy = (Math.random() - 0.5) * T * 3.5;
        var size = T * (1.2 + Math.random() * 1.3);
        scene.add.ellipse(cx + ox, cy + oy, size, size * 0.7, greens[p % 3], 0.55).setDepth(2);
      }
      scene.add.ellipse(cx, cy, T * 5, T * 4, 0x05ffa1, 0.12).setDepth(3);
      addWall(cx - T * 2.5, cy - T * 2, T * 5, T * 4);
    }
  };

  // ---- Element Placement Helpers ----
  // Returns a tile position that doesn't overlap any blocked zone, or null after N attempts.
  // blockedZones: array of {x, y, w, h} — tile coordinates, rectangular blocks.
  function pickRandomPosition(MW, MH, blockedZones) {
    blockedZones = blockedZones || [];
    for (var attempts = 0; attempts < 15; attempts++) {
      var x = 2 + Math.random() * (MW - 4);
      var y = 2 + Math.random() * (MH - 4);
      var blocked = false;
      for (var i = 0; i < blockedZones.length; i++) {
        var z = blockedZones[i];
        // Expand zone by 0.5 tile padding to avoid hugging edges
        if (x > z.x - 0.5 && x < z.x + z.w + 0.5 && y > z.y - 0.5 && y < z.y + z.h + 0.5) {
          blocked = true; break;
        }
      }
      if (!blocked) return [x, y];
    }
    return null;
  }

  // Build the list of blocked zones for a given floor data snapshot
  function buildBlockedZones(floorData, MW, MH) {
    var zones = [];
    // Center element (5x4 centered below mall center)
    zones.push({ x: MW / 2 - 2.5, y: MH / 2 + 2, w: 5, h: 4 });

    // Escalator area (center top)
    zones.push({ x: MW / 2 - 4, y: 8, w: 8, h: 5 });

    // Store positions (4 corners) — 10x7 blocks + doors
    zones.push({ x: 2,  y: 2,  w: 12, h: 10 });  // top-left
    zones.push({ x: 36, y: 2,  w: 12, h: 10 });  // top-right
    zones.push({ x: 2,  y: 27, w: 12, h: 9 });   // bottom-left
    zones.push({ x: 36, y: 27, w: 12, h: 9 });   // bottom-right

    // Kiosks (based on current floor's blocks)
    (floorData.kiosks || []).forEach(function (k) {
      var pos = KIOSK_POSITION_MAP[k.position];
      if (pos) zones.push({ x: pos.x - 1, y: pos.y - 1, w: pos.w + 2, h: pos.h + 2 });
    });

    // Map board
    zones.push({ x: 16.5, y: 12.75, w: 3, h: 2.5 });

    return zones;
  }

  // ---- Element spawners — small functions that place a single decoration ----
  var SPAWNERS = {
    palm: function (scene, x, y, addWall) {
      scene.add.image(x * T, y * T, 'palm').setDepth(2);
      addWall(x * T - T / 2, y * T + T, T, T);
    },
    planter: function (scene, x, y, addWall) {
      scene.add.image(x * T, y * T, 'planter').setDepth(2);
      addWall(x * T - T / 3, y * T + T / 2, T * 0.7, T * 0.7);
    },
    bench: function (scene, x, y, addWall) {
      scene.add.image(x * T, y * T, 'bench').setDepth(2);
      addWall(x * T - T, y * T - T / 4, T * 2, T * 0.8);
    },
    neonPuddle: function (scene, x, y) {
      var cols = [0xff71ce, 0x01cdfe, 0xb967ff, 0x05ffa1];
      var col = cols[Math.floor(Math.random() * cols.length)];
      var puddle = scene.add.rectangle(x * T, y * T, T * 2.5, T * 0.4, col, 0.05).setDepth(0);
      scene.tweens.add({ targets: puddle, alpha: { from: 0.02, to: 0.08 }, duration: 2000 + Math.random() * 3000, yoyo: true, repeat: -1 });
    },
    glowOrb: function (scene, x, y) {
      var cols = [0xff71ce, 0x01cdfe, 0xb967ff, 0xfffb96];
      var col = cols[Math.floor(Math.random() * cols.length)];
      var orb = scene.add.circle(x * T, y * T, 3 + Math.random() * 3, col, 0.7).setDepth(50);
      scene.tweens.add({
        targets: orb, alpha: { from: 0.3, to: 0.9 },
        x: orb.x + (Math.random() - 0.5) * T * 4,
        y: orb.y + (Math.random() - 0.5) * T * 3,
        duration: 2000 + Math.random() * 3000, yoyo: true, repeat: -1, ease: 'Sine.easeInOut'
      });
    },
    rock: function (scene, x, y, addWall) {
      scene.add.ellipse(x * T, y * T, T * 1.5, T, 0x5a5a6a, 0.6).setDepth(2);
      scene.add.ellipse(x * T - 2, y * T - 2, T * 1.3, T * 0.8, 0x6a6a7a, 0.4).setDepth(2);
      addWall(x * T - T * 0.75, y * T - T / 2, T * 1.5, T);
    },
    bamboo: function (scene, x, y, addWall) {
      for (var s = 0; s < 3; s++) {
        var bx = x * T + (s - 1) * 6;
        scene.add.rectangle(bx, y * T - T, 3, T * 2, 0x4a8a3a, 0.7).setDepth(2);
        scene.add.ellipse(bx, y * T - T * 1.5, 8, 5, 0x3a7a2a, 0.6).setDepth(3);
      }
      addWall(x * T - T / 2, y * T, T, T);
    },
    jukebox: function (scene, x, y, addWall) {
      var cols = [0xff71ce, 0x01cdfe, 0xb967ff, 0x05ffa1];
      var col = cols[Math.floor(Math.random() * cols.length)];
      scene.add.rectangle(x * T, y * T, T * 1.2, T * 1.8, 0x4a2040, 0.9).setDepth(2);
      var glow = scene.add.rectangle(x * T, y * T - T * 0.3, T * 0.8, T * 0.6, col, 0.2).setDepth(3);
      scene.tweens.add({ targets: glow, alpha: { from: 0.1, to: 0.35 }, duration: 1200, yoyo: true, repeat: -1 });
      addWall(x * T - T * 0.6, y * T - T * 0.9, T * 1.2, T * 1.8);
    },
    crystalShard: function (scene, x, y, addWall) {
      var cols = [0x01cdfe, 0xb967ff, 0xff71ce, 0x05ffa1];
      var col = cols[Math.floor(Math.random() * cols.length)];
      var h = T * (1 + Math.random());
      scene.add.triangle(x * T, y * T, 0, h, h * 0.4, 0, h * 0.8, h, col, 0.4).setDepth(2);
      var glow = scene.add.circle(x * T + h * 0.2, y * T, h * 0.9, col, 0.08).setDepth(1);
      scene.tweens.add({ targets: glow, alpha: { from: 0.03, to: 0.12 }, duration: 1500 + Math.random() * 2000, yoyo: true, repeat: -1 });
      addWall(x * T - T * 0.3, y * T - T * 0.3, T * 0.6, T * 0.6);
    },
    mistPatch: function (scene, x, y) {
      var mist = scene.add.ellipse(x * T, y * T, T * 4, T * 2, 0xb967ff, 0.04).setDepth(0);
      scene.tweens.add({ targets: mist, alpha: { from: 0.01, to: 0.06 }, x: mist.x + T, duration: 4000 + Math.random() * 3000, yoyo: true, repeat: -1 });
    },
    plant: function (scene, x, y) {
      var greens = [0x0a6b3d, 0x0d8a4e, 0x10a85f];
      var col = greens[Math.floor(Math.random() * 3)];
      var size = T * (0.8 + Math.random() * 1.4);
      scene.add.ellipse(x * T, y * T, size, size * 0.7, col, 0.35).setDepth(2);
      if (Math.random() > 0.6) scene.add.ellipse(x * T, y * T, size * 0.5, size * 0.3, 0x05ffa1, 0.15).setDepth(3);
    },
    firefly: function (scene, x, y) {
      var fly = scene.add.circle(x * T, y * T, 2, 0xfffb96, 0.7).setDepth(50);
      scene.tweens.add({
        targets: fly, x: fly.x + (Math.random() - 0.5) * T * 3, y: fly.y + (Math.random() - 0.5) * T * 2, alpha: { from: 0.2, to: 0.9 },
        duration: 2000 + Math.random() * 3000, yoyo: true, repeat: -1, ease: 'Sine.easeInOut'
      });
    },
    checkerAccent: function (scene, x, y) {
      var col = (Math.floor(x) % 2 === 0) ? 0xff4444 : 0xffffff;
      scene.add.rectangle(x * T, y * T, T, T * 0.5, col, 0.12).setDepth(0);
    }
  };

  // ---- Element Sets — fixed anchors + random scatter pool ----
  // density: 0-200, where 100 = "normal" (we normalize to a multiplier here)
  var ELEMENT_SETS = {
    'vaporwave-oasis': {
      fixed: [ { spawner: 'palm', positions: [[3, 20], [47, 20], [16, 15], [34, 15], [16, 32], [34, 32]] } ],
      pool: ['neonPuddle', 'neonPuddle', 'neonPuddle', 'glowOrb', 'palm', 'palm'],
      baseCount: 25
    },
    'cyber-lounge': {
      fixed: [
        { spawner: 'bench', positions: [[20, 16], [29, 16], [20, 30], [29, 30]] }
      ],
      pool: ['planter', 'planter', 'glowOrb', 'glowOrb', 'neonPuddle'],
      baseCount: 20
    },
    'zen-garden': {
      fixed: [
        { spawner: 'bamboo', positions: [[4, 20], [46, 20]] }
      ],
      pool: ['rock', 'bamboo', 'plant', 'plant', 'glowOrb'],
      baseCount: 18
    },
    'retro-diner': {
      fixed: [],
      pool: ['jukebox', 'jukebox', 'neonPuddle', 'glowOrb', 'checkerAccent', 'checkerAccent'],
      baseCount: 22
    },
    'crystal-cave': {
      fixed: [],
      pool: ['crystalShard', 'crystalShard', 'mistPatch', 'glowOrb', 'glowOrb'],
      baseCount: 24
    },
    'neon-jungle': {
      fixed: [],
      pool: ['plant', 'plant', 'plant', 'firefly', 'firefly', 'neonPuddle'],
      baseCount: 30
    },
    'custom': {
      // Filled in at runtime from uploaded images
      fixed: [],
      pool: [],
      baseCount: 30
    }
  };

  // Place an element set's fixed anchors + scatter random pool elements
  function placeElementSet(scene, setKey, MW, MH, addWall, density, floorData) {
    var set = ELEMENT_SETS[setKey] || ELEMENT_SETS['vaporwave-oasis'];
    // Fixed elements always placed
    (set.fixed || []).forEach(function (group) {
      var fn = SPAWNERS[group.spawner];
      if (!fn) return;
      group.positions.forEach(function (pos) {
        fn(scene, pos[0], pos[1], addWall);
      });
    });

    // If custom set, build pool from uploaded images
    var activePool = set.pool.slice();
    var customSpawners = {};
    if (setKey === 'custom' && floorData) {
      var floor = floorData.floor;
      // Animated elements — placed higher, tween with pulse/float
      ['customAnim1', 'customAnim2'].forEach(function (field) {
        var texKey = 'ceset-' + floor + '-' + field;
        if (scene.textures.exists(texKey)) {
          var name = 'custom-' + field;
          var styleKey = field === 'customAnim1' ? 'customAnim1Style' : 'customAnim2Style';
          var style = floorData[styleKey] || (field === 'customAnim2' ? 'fade' : 'both');
          customSpawners[name] = (function (key, animStyle) {
            return function (sc, x, y) {
              var img = sc.add.image(x * T, y * T, key).setDepth(50);
              img.setDisplaySize(T, T);
              var tween = {
                targets: img,
                duration: 1500 + Math.random() * 1500,
                yoyo: true, repeat: -1, ease: 'Sine.easeInOut'
              };
              if (animStyle === 'float') {
                tween.y = img.y - T * 0.4;
              } else if (animStyle === 'fade') {
                tween.alpha = { from: 0.1, to: 1 };
              } else { // 'both'
                tween.y = img.y - T * 0.3;
                tween.alpha = { from: 0.4, to: 1 };
              }
              sc.tweens.add(tween);
            };
          })(texKey, style);
          // Weight animated elements more
          activePool.push(name, name);
        }
      });
      // Floor elements — placed on ground, static
      ['customFloor1', 'customFloor2'].forEach(function (field) {
        var texKey = 'ceset-' + floor + '-' + field;
        if (scene.textures.exists(texKey)) {
          var name = 'custom-' + field;
          customSpawners[name] = (function (key) {
            return function (sc, x, y) {
              var img = sc.add.image(x * T, y * T, key).setDepth(2);
              img.setDisplaySize(T, T);
            };
          })(texKey);
          activePool.push(name, name);
        }
      });
      // Tall element — native-ish size (2T × 3T, like the palm), collision at base
      (function () {
        var field = 'customTall';
        var texKey = 'ceset-' + floor + '-' + field;
        if (!scene.textures.exists(texKey)) return;
        var name = 'custom-' + field;
        customSpawners[name] = (function (key) {
          return function (sc, x, y, addWall) {
            // Anchor by bottom-center so it grows UP from the tile, like the palm
            var img = sc.add.image(x * T, y * T, key).setOrigin(0.5, 1).setDepth(3);
            img.setDisplaySize(T * 2, T * 3);
            if (addWall) addWall(x * T - T / 2, y * T - T / 2, T, T);
          };
        })(texKey);
        activePool.push(name, name);
      })();
    }

    // Random scatter — density is 0..200 (0 = none, 100 = normal, 200 = max)
    if (activePool.length === 0) return;
    var blockedZones = floorData ? buildBlockedZones(floorData, MW, MH) : [];
    var count = Math.round((set.baseCount || 20) * (density / 100));
    for (var i = 0; i < count; i++) {
      var pos = pickRandomPosition(MW, MH, blockedZones);
      if (!pos) continue;
      var spawnerKey = activePool[Math.floor(Math.random() * activePool.length)];
      var fn = customSpawners[spawnerKey] || SPAWNERS[spawnerKey];
      if (fn) fn(scene, pos[0], pos[1], addWall);
    }
  }

  // ---- Cart update helper ----
  function updateCartCount() {
    // Delegate to the vapor-cart.js drawer refresh when available — that rebuilds
    // the item list too. Fall back to just updating the count badge.
    if (window.VaporCart && typeof window.VaporCart.refresh === 'function') {
      window.VaporCart.refresh();
      return;
    }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var el = document.getElementById('hud-cart-count');
      if (el) el.textContent = cart.item_count;
    });
  }

  // Shared price formatter — handles cents-as-int, dollars-as-string ("19.99"),
  // and cents-as-string edge cases. Returns "$—" if unparseable.
  function _formatPrice(raw) {
    if (typeof raw === 'number' && isFinite(raw)) {
      return '$' + (raw > 1000 ? (raw / 100).toFixed(2) : raw.toFixed(2));
    }
    if (typeof raw === 'string' && raw) {
      var n = parseFloat(raw);
      if (isNaN(n)) return '$—';
      // Strings from /collections/*/products.json are dollars like "19.99".
      // Strings without a decimal we treat as cents to be safe.
      return raw.indexOf('.') >= 0 ? '$' + n.toFixed(2) : '$' + (n / 100).toFixed(2);
    }
    return '$—';
  }

  // The mall's own drawer is retired — MegaCart (app embed) is the cart now.
  // MegaCart auto-opens on add via its fetch interceptor; open it explicitly
  // here too as a safety in case openOnAdd is off for the assigned cart.
  function _openVaporCartSuppressNative() {
    if (window.__v95openDrawer) window.__v95openDrawer();
  }

  // ============================================
  // BOOT SCENE
  // ============================================
  class BootScene extends Phaser.Scene {
    constructor() { super('Boot'); }

    preload() {
      var bar = document.getElementById('loading-bar-fill');
      this.load.on('progress', function (v) { if (bar) bar.style.width = (v * 100) + '%'; });

      // Load floor data early so we can queue custom image loads
      loadFloorData();

      // Queue custom asset loads
      var self = this;
      CONFIG.floors.forEach(function (floor) {
        if (floor.customFloorTile) {
          self.load.image('custom-floor-tile-' + floor.floor, floor.customFloorTile);
        }
        if (floor.customElementImage) {
          self.load.image('custom-element-' + floor.floor, floor.customElementImage);
        }
        (floor.stores || []).forEach(function (store) {
          var key = 'f' + floor.floor + '-' + store.position;
          if (store.customStorefront) self.load.image('custom-storefront-' + key, store.customStorefront);
          if (store.customSign) self.load.image('custom-sign-' + key, store.customSign);
          if (store.interactableImage) self.load.image('interactable-img-' + key, store.interactableImage);
        });
        (floor.kiosks || []).forEach(function (kiosk) {
          var kkey = 'f' + floor.floor + '-' + kiosk.position + '-kiosk';
          if (kiosk.customImage) self.load.image('custom-kiosk-' + kkey, kiosk.customImage);
        });
        (floor.npcs || []).forEach(function (npc, idx) {
          var nkey = 'f' + floor.floor + '-npc-' + idx;
          if (npc.customSprite) self.load.image('custom-' + nkey, npc.customSprite);
        });
        // Custom element set images
        ['customAnim1', 'customAnim2', 'customFloor1', 'customFloor2', 'customTall'].forEach(function (field) {
          if (floor[field]) self.load.image('ceset-' + floor.floor + '-' + field, floor[field]);
        });
      });
      // Theme-level map images
      if (CONFIG.map) {
        if (CONFIG.map.boardImage) self.load.image('map-board', CONFIG.map.boardImage);
      }
      // Theme-level basement door image (replaces the procedural purple-neon doorway on Floor 1)
      if (CONFIG.basementDoorImage) self.load.image('basement-door', CONFIG.basementDoorImage);
    }

    create() {
      VaporSprites.loadIntoPhaser(this);
      registerSpriteFrames(this, 'player-default');
      MusicController.armUnlock();

      var saved = localStorage.getItem('vapor-mall-avatar');
      if (saved) {
        var opts = JSON.parse(saved);
        var sc = VaporSprites.genPlayerSprite(opts);
        if (this.textures.exists('player')) this.textures.remove('player');
        this.textures.addCanvas('player', sc);
        registerSpriteFrames(this, 'player');
        this.scene.start('MallFloor1');
      } else {
        this.scene.start('AvatarCreate');
      }

      var loading = document.getElementById('vapor-loading');
      if (loading) loading.classList.add('loading-screen--hidden');
    }
  }

  // ============================================
  // AVATAR CREATION SCENE
  // ============================================
  class AvatarCreateScene extends Phaser.Scene {
    constructor() { super('AvatarCreate'); }

    create() {
      this.avatarOpts = { skin: '#f5c6a0', shirt: '#ff71ce', pants: '#2a1f3d', hair: '#1a1a2e', hairStyle: 0 };
      var el = document.getElementById('vapor-avatar-creator');
      el.classList.remove('avatar-creator--hidden');
      var self = this;

      this._picker('avatar-skin-colors', getAvatarPalette('skin'), 'skin');
      this._picker('avatar-shirt-colors', getAvatarPalette('shirt'), 'shirt');
      this._picker('avatar-hair-colors', getAvatarPalette('hair'), 'hair');
      this._styles();
      this._preview();

      document.getElementById('avatar-confirm').onclick = function () {
        localStorage.setItem('vapor-mall-avatar', JSON.stringify(self.avatarOpts));
        var sc = VaporSprites.genPlayerSprite(self.avatarOpts);
        if (self.textures.exists('player')) self.textures.remove('player');
        self.textures.addCanvas('player', sc);
        registerSpriteFrames(self, 'player');
        el.classList.add('avatar-creator--hidden');
        self.scene.start('MallFloor1');
      };
    }

    _picker(id, colors, prop) {
      var c = document.getElementById(id); c.innerHTML = ''; var self = this;
      colors.forEach(function (col) {
        var s = document.createElement('div');
        s.className = 'color-swatch' + (self.avatarOpts[prop] === col ? ' color-swatch--active' : '');
        s.style.background = col;
        s.onclick = function () { self.avatarOpts[prop] = col; c.querySelectorAll('.color-swatch').forEach(function (x) { x.classList.remove('color-swatch--active'); }); s.classList.add('color-swatch--active'); self._preview(); };
        c.appendChild(s);
      });
    }

    _styles() {
      var c = document.getElementById('avatar-hair-styles'); c.innerHTML = ''; var self = this;
      ['SHORT', 'LONG', 'SPIKY', 'BALD'].forEach(function (n, i) {
        var b = document.createElement('button'); b.className = 'style-btn' + (i === 0 ? ' style-btn--active' : ''); b.textContent = n;
        b.onclick = function () { self.avatarOpts.hairStyle = i; c.querySelectorAll('.style-btn').forEach(function (x) { x.classList.remove('style-btn--active'); }); b.classList.add('style-btn--active'); self._preview(); };
        c.appendChild(b);
      });
    }

    _preview() {
      var ctx = document.getElementById('avatar-preview').getContext('2d');
      ctx.clearRect(0, 0, 128, 128); ctx.imageSmoothingEnabled = false;
      var s = VaporSprites.genPlayerSprite(this.avatarOpts);
      ctx.drawImage(s, 0, 0, VaporSprites.SPRITE_W * 2, VaporSprites.SPRITE_H * 2, 16, 8, 96, 112);
    }
  }

  // ============================================
  // MALL FLOOR BASE — shared logic for all floors
  // ============================================
  class MallFloorBase extends Phaser.Scene {
    constructor(key) { super(key); }

    initFloor(floorNum) {
      this.floorNum = floorNum;
      var floorData = getFloor(floorNum) || { visible: true, floorTiles: 'marble-classic', elementSet: 'vaporwave-oasis', stores: [] };
      this.floorData = floorData;
      this.playerSpeed = 160;
      this.nearShop = null;
      this.nearEscalator = null;
      this.chatFocused = false;
      this.transitioning = false;

      this.cursors = this.input.keyboard.createCursorKeys();
      this.wasd = this.input.keyboard.addKeys('W,A,S,D');
      this.enterKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER);

      this._buildWorld();
      this._createPlayer();
      this._setupCamera();
      this._setupChat();
      this._setupTouchJoystick();
      // Basement stays eerie and empty — only interactable NPCs added via theme editor
      if (this.floorNum !== 'Basement') this._setupNPCs();
      else { this.npcs = []; this._setupBasementAtmosphere(); }
      this._updateHUD();

      // Multiplayer: join channel for this floor, render remotes, route chat
      this._setupMultiplayer();

      var self = this;
      var chatInput = document.getElementById('chat-input');
      if (chatInput) {
        chatInput.addEventListener('focus', function () { self.chatFocused = true; });
        chatInput.addEventListener('blur', function () { self.chatFocused = false; });
      }

      // Shared "do whatever the player is currently near" function — used by
      // both the ENTER key (desktop) and tap on the prompt / world objects (mobile)
      this._triggerNearestInteract = function () {
        if (self.chatFocused || self.transitioning) return;
        if (self.nearShop !== null) self._openSection(self.nearShop);
        else if (self.nearKiosk) self._openKiosk(self.nearKiosk);
        else if (self.nearNPC) self._openKiosk(self.nearNPC);
        else if (self.nearMap) self._openMap(self.nearMap);
        else if (self.nearEscalator) self._useEscalator(self.nearEscalator);
      };
      this.enterKey.on('down', this._triggerNearestInteract);

      // Interact prompt — reuse single shared DOM element
      var existingPrompt = document.getElementById('vapor-interact-prompt');
      if (existingPrompt) {
        this.interactPrompt = existingPrompt;
      } else {
        this.interactPrompt = document.createElement('div');
        this.interactPrompt.id = 'vapor-interact-prompt';
        this.interactPrompt.className = 'interact-prompt';
        document.body.appendChild(this.interactPrompt);
      }
      this.interactPrompt.textContent = '';
      this.interactPrompt.classList.remove('interact-prompt--visible');
      // Tap-to-trigger on the prompt itself (mobile)
      var triggerFn = this._triggerNearestInteract;
      var prevHandler = this.interactPrompt._tapHandler;
      if (prevHandler) {
        this.interactPrompt.removeEventListener('click', prevHandler);
        this.interactPrompt.removeEventListener('touchend', prevHandler);
      }
      var newHandler = function (e) { e.preventDefault(); e.stopPropagation(); triggerFn(); };
      this.interactPrompt._tapHandler = newHandler;
      this.interactPrompt.addEventListener('click', newHandler);
      this.interactPrompt.addEventListener('touchend', newHandler);

      this.cameras.main.fadeIn(600, 26, 26, 46);

      // Per-floor music — playlist cycles; autoplay is armed in BootScene
      var tracks = floorData.floorTracks;
      if (!tracks || !tracks.length) {
        // Back-compat with earlier single-track shape
        tracks = floorData.floorMusic ? [{ url: floorData.floorMusic, name: floorData.floorMusicName || '' }] : [];
      }
      MusicController.setPlaylist(tracks);

      // Wire mute button (idempotent; first init binds, subsequent updates the icon state)
      var muteBtn = document.getElementById('hud-mute-btn');
      if (muteBtn && !muteBtn._mcBound) {
        muteBtn._mcBound = true;
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          MusicController.setMuted(!MusicController.isMuted());
          MusicController.tryPlay();
        });
      }
      if (muteBtn) muteBtn.classList.toggle('hud__mute-btn--muted', MusicController.isMuted());
    }

    _buildWorld() {
      var fd = this.floorData;
      // Use custom uploaded floor tile if available, otherwise use preset
      var customFloorKey = 'custom-floor-tile-' + this.floorNum;
      var tileKey = this.textures.exists(customFloorKey) ? customFloorKey : 'tile-' + (fd.floorTiles || 'marble-classic');
      if (!this.textures.exists(tileKey)) tileKey = 'tile-marble-classic';

      // Floor tiles
      for (var y = 0; y < FLOOR_H; y++)
        for (var x = 0; x < FLOOR_W; x++)
          this.add.image(x * T + T / 2, y * T + T / 2, tileKey).setDepth(0);

      // Corridor stripe
      var mid = Math.floor(FLOOR_W / 2);
      for (var cy = 0; cy < FLOOR_H; cy++) {
        this.add.rectangle((mid - 1) * T + T / 2, cy * T + T / 2, T, T, 0x2a1f3d, 0.2).setDepth(0);
        this.add.rectangle(mid * T + T / 2, cy * T + T / 2, T, T, 0x2a1f3d, 0.2).setDepth(0);
        this.add.rectangle((mid + 1) * T + T / 2, cy * T + T / 2, T, T, 0x2a1f3d, 0.2).setDepth(0);
      }

      // Walls
      this.walls = this.physics.add.staticGroup();
      for (var wx = 0; wx < FLOOR_W; wx++) {
        this.add.image(wx * T + T / 2, T / 2, 'tile-wall').setDepth(1);
        this.add.image(wx * T + T / 2, T + T / 2, 'tile-wall').setDepth(1).setAlpha(0.7);
        this.add.image(wx * T + T / 2, (FLOOR_H - 1) * T + T / 2, 'tile-wall').setDepth(1);
      }
      for (var wy = 0; wy < FLOOR_H; wy++) {
        this.add.image(T / 2, wy * T + T / 2, 'tile-wall').setDepth(1);
        this.add.image((FLOOR_W - 1) * T + T / 2, wy * T + T / 2, 'tile-wall').setDepth(1);
      }
      this._wall(0, 0, FLOOR_W * T, T * 2);
      this._wall(0, (FLOOR_H - 1) * T, FLOOR_W * T, T);
      this._wall(0, 0, T, FLOOR_H * T);
      this._wall((FLOOR_W - 1) * T, 0, T, FLOOR_H * T);

      // Shops
      this.shopZones = [];
      var self = this;
      (fd.stores || []).forEach(function (store) {
        var pos = POSITION_MAP[store.position];
        if (pos) self._buildShop(store, pos);
      });

      // Kiosks
      this.kioskZones = [];
      (fd.kiosks || []).forEach(function (kiosk) {
        var kpos = KIOSK_POSITION_MAP[kiosk.position];
        if (kpos) self._buildKiosk(kiosk, kpos);
      });

      // Interactable NPCs
      this.interactableNPCs = [];
      (fd.npcs || []).forEach(function (npc, idx) {
        self._buildInteractableNPC(npc, idx);
      });

      // Map Board — enabled per floor from theme settings (skip for the secret basement)
      this.mapZones = [];
      var isBasement = this.floorNum === 'Basement';
      if (!isBasement) {
        var mapSettings = CONFIG.map || {};
        var mapFlag = ['floor1Enabled', 'floor2Enabled', 'floor3Enabled', 'floor4Enabled', 'floor5Enabled'][this.floorNum - 1];
        if (mapSettings[mapFlag] !== false) self._buildMapBoard(fd);
      }

      // Escalators — find nearest visible floor above and below
      this.escalatorZones = [];
      if (isBasement) {
        // Basement has no numeric neighbors — a stone staircase back up to Floor 1
        this._buildStairs(BASEMENT_RETURN, 1);
      } else {
        var nextUp = null;
        for (var u = this.floorNum + 1; u <= 5; u++) if (isFloorVisible(u)) { nextUp = u; break; }
        var nextDown = null;
        for (var d = this.floorNum - 1; d >= 1; d--) if (isFloorVisible(d)) { nextDown = d; break; }
        if (nextUp) this._buildEscalator(ESCALATOR_UP, 'up', nextUp);
        if (nextDown) this._buildEscalator(ESCALATOR_DOWN, 'down', nextDown);
        // Secret basement door — only on Floor 1, only if basement is enabled
        if (this.floorNum === 1 && isFloorVisible('Basement')) {
          this._buildBasementDoor(BASEMENT_DOOR);
        }
      }

      // Center Element — uploaded image > selected center preset > element set default
      // Size: 5 tiles wide × 4 tiles tall
      var cx = (FLOOR_W / 2) * T, cy = (FLOOR_H / 2 + 4) * T;
      var customElemKey = 'custom-element-' + this.floorNum;
      if (fd.customElementImage) {
        // DOM overlay — lets animated PNGs (APNG) animate natively in the browser
        this._centerElementOverlay = this._createCenterOverlay(fd.customElementImage, cx, cy, T * 5, T * 4);
        self._wall(cx - T * 2.5, cy - T * 2, T * 5, T * 4);
      } else if (this.textures.exists(customElemKey)) {
        var elemSprite = this.add.image(cx, cy, customElemKey).setDepth(2);
        elemSprite.setDisplaySize(T * 5, T * 4);
        self._wall(cx - T * 2.5, cy - T * 2, T * 5, T * 4);
      } else {
        // Which center to render? Explicit center, or auto from element set
        var centerKey = fd.centerElement;
        if (!centerKey || centerKey === 'auto') {
          centerKey = SET_DEFAULT_CENTER[fd.elementSet] || 'fountain';
        }
        var centerFn = CENTER_ELEMENTS[centerKey];
        if (centerFn) centerFn(this, cx, cy, self._wall.bind(self));
      }

      // Element set — fixed anchors + randomized scatter scaled by density (0-200)
      var density = typeof fd.elementDensity === 'number' ? fd.elementDensity : 50;
      placeElementSet(this, fd.elementSet || 'vaporwave-oasis', FLOOR_W, FLOOR_H, self._wall.bind(self), density, fd);

      // Ceiling shadows for depth
      for (var sx = 2; sx < FLOOR_W - 2; sx += 6)
        this.add.rectangle(sx * T + T * 3, T * 2.5, T * 6, T * 0.5, 0x000000, 0.08).setDepth(0);
    }

    _wall(x, y, w, h) {
      var r = this.add.rectangle(x + w / 2, y + h / 2, w, h, 0x000000, 0);
      this.physics.add.existing(r, true);
      this.walls.add(r);
    }

    _buildShop(store, pos) {
      var key = 'f' + this.floorNum + '-' + store.position;
      var pulseColor = store.signPulseColor || '#ff71ce';
      var pulseHex = parseInt(pulseColor.replace('#', ''), 16);
      var pulseSpeed = store.signPulseSpeed || 1500;
      var pulseOn = store.signPulse !== false;

      // If this section is an Interactable Object, prefer its custom image
      var interactableImgKey = 'interactable-img-' + key;
      var hasInteractableImg = store.contentType === 'interactable' && this.textures.exists(interactableImgKey);

      // Custom uploaded assets take priority over procedural ones
      var customSfKey = hasInteractableImg ? interactableImgKey : ('custom-storefront-' + key);
      var hasCustomFullSprite = this.textures.exists(customSfKey);
      var tileSfKey = this.textures.exists('storefront-' + key) ? 'storefront-' + key : 'tile-wall';
      var doorKey = this.textures.exists('door-' + key) ? 'door-' + key : 'tile-wall';
      var customSignKey = 'custom-sign-' + key;
      var signKey = this.textures.exists(customSignKey) ? customSignKey :
                    this.textures.exists('sign-' + key) ? 'sign-' + key : null;

      var facingTop = pos.facing === 'top';
      var frontRowY = facingTop ? pos.y : pos.y + pos.h - 1;

      if (hasCustomFullSprite) {
        // Custom storefront image covers whole block as one sprite
        var blockCenterX = (pos.x + pos.w / 2) * T;
        var blockCenterY = (pos.y + pos.h / 2) * T;
        var sprite = this.add.image(blockCenterX, blockCenterY, customSfKey).setDepth(1);
        // Flip vertically if facing top (bottom stores) so the sprite reads correctly
        if (facingTop) sprite.setFlipY(true);
        sprite.setDisplaySize(pos.w * T, pos.h * T);
      } else {
        // Procedural: back walls solid, front row uses style tile
        for (var y = pos.y; y < pos.y + pos.h; y++)
          for (var x = pos.x; x < pos.x + pos.w; x++)
            this.add.image(x * T + T / 2, y * T + T / 2, y === frontRowY ? tileSfKey : 'tile-wall').setDepth(1);
      }

      // Interior glow
      var ig = this.add.rectangle((pos.x + pos.w / 2) * T, (pos.y + pos.h / 2) * T, (pos.w - 2) * T, (pos.h - 2) * T, pulseHex, 0.04).setDepth(0);
      this.tweens.add({ targets: ig, alpha: { from: 0.02, to: 0.06 }, duration: 2000, yoyo: true, repeat: -1 });

      this._wall(pos.x * T, pos.y * T, pos.w * T, pos.h * T);

      // (Door tile removed — entire storefront is interactable instead)

      // Sign ON the front wall (top or bottom depending on facing)
      var signCX = (pos.x + pos.w / 2) * T;
      var frontY = frontRowY * T + T / 2;
      var signOffset = facingTop ? T * 0.3 : -T * 0.3;
      var glowOffset = facingTop ? -T * 0.3 : T * 0.3;

      if (signKey) {
        var sign = this.add.image(signCX, frontY + signOffset, signKey).setDepth(50);
        if (pulseOn) this.tweens.add({ targets: sign, alpha: { from: 0.7, to: 1 }, duration: pulseSpeed, yoyo: true, repeat: -1, ease: 'Sine.easeInOut' });
      }

      // Glow bar
      var glow = this.add.rectangle(signCX, frontY + glowOffset, T * 6, T * 0.25, pulseHex, 0.2).setDepth(49);
      if (pulseOn) this.tweens.add({ targets: glow, alpha: { from: 0.1, to: 0.3 }, duration: pulseSpeed, yoyo: true, repeat: -1 });

      // Interaction zone — covers the whole store footprint + 1-tile margin
      // so the player can approach from any side.
      var zoneCx = (pos.x + pos.w / 2) * T;
      var zoneCy = (pos.y + pos.h / 2) * T;
      var zoneW = (pos.w + 2) * T;
      var zoneH = (pos.h + 2) * T;
      var zone = this.add.zone(zoneCx, zoneCy, zoneW, zoneH);
      this.physics.add.existing(zone, true);
      zone.storeData = store;
      zone._bx = zoneCx - zoneW / 2;
      zone._by = zoneCy - zoneH / 2;
      zone._bw = zoneW;
      zone._bh = zoneH;
      // Tap-to-open (mobile) — tapping anywhere on the store opens it directly
      zone.setInteractive(new Phaser.Geom.Rectangle(0, 0, zoneW, zoneH), Phaser.Geom.Rectangle.Contains);
      zone.input.cursor = 'pointer';
      var selfBuild = this;
      zone.on('pointerdown', function (pointer) {
        if (selfBuild.transitioning) return;
        selfBuild._openSection(store);
      });
      this.shopZones.push(zone);
    }

    _buildMapBoard(fd) {
      var mx = 18, my = 14;
      var cx = mx * T, cy = my * T;
      var boardW = T * 3;
      var boardH = T * 2.5;

      // Custom board sprite (if uploaded) renders as a backdrop; procedural UI always draws on top.
      var hasCustomBoard = this.textures.exists('map-board');
      if (hasCustomBoard) {
        var img = this.add.image(cx, cy, 'map-board').setDepth(2);
        img.setDisplaySize(boardW, boardH);
      } else {
        // Default procedural board backing
        this.add.rectangle(cx, cy, boardW, boardH, 0x1a1a2e, 0.95).setDepth(2);
        this.add.rectangle(cx, cy, boardW + 4, boardH + 4, 0xff71ce, 0).setStrokeStyle(2, 0xff71ce, 0.8).setDepth(3);
      }
      // MAP label + mini-map + store dots — always visible regardless of backdrop.
      // Sized to fit inside a custom board frame that's T*3 × T*2.5.
      this.add.text(cx, cy - T * 0.55, 'MAP', {
        fontFamily: '"Press Start 2P"', fontSize: '7px', color: '#ff71ce'
      }).setOrigin(0.5).setDepth(4);
      var miniW = T * 1.7, miniH = T * 0.9;
      // Slightly more opaque backing for readability over custom board art
      this.add.rectangle(cx, cy + T * 0.25, miniW, miniH, 0x0a0a16, hasCustomBoard ? 0.85 : 0.9).setDepth(4);
      var dotPositions = { 'top-left': [-0.6, -0.3], 'top-right': [0.6, -0.3], 'bottom-left': [-0.6, 0.3], 'bottom-right': [0.6, 0.3] };
      (fd.stores || []).forEach(function (store) {
        var offset = dotPositions[store.position];
        if (!offset) return;
        var dotX = cx + offset[0] * T * 0.55;
        var dotY = cy + T * 0.25 + offset[1] * T * 0.28;
        this.add.rectangle(dotX, dotY, 4, 4, parseInt((store.signPulseColor || '#ff71ce').replace('#', ''), 16), 1).setDepth(5);
      }.bind(this));

      // Pulse glow (always present)
      var glow = this.add.rectangle(cx, cy, boardW + 8, boardH + 8, 0xff71ce, 0.08).setDepth(1);
      this.tweens.add({ targets: glow, alpha: { from: 0.05, to: 0.15 }, duration: 2000, yoyo: true, repeat: -1 });

      this._wall(cx - boardW / 2, cy - boardH / 2, boardW, boardH);
      var zone = this.add.zone(cx, cy + T * 2, boardW, T * 2);
      this.physics.add.existing(zone, true);
      zone.mapData = fd;
      // Tap-to-open the map
      var selfM = this;
      zone.setInteractive(new Phaser.Geom.Rectangle(0, 0, boardW, T * 2), Phaser.Geom.Rectangle.Contains);
      zone.input.cursor = 'pointer';
      zone.on('pointerdown', function () {
        if (selfM.transitioning) return;
        selfM._openMap(fd);
      });
      // Also make the board art itself tappable (above the zone)
      var boardZone = this.add.zone(cx, cy, boardW, boardH);
      this.physics.add.existing(boardZone, true);
      boardZone.setInteractive(new Phaser.Geom.Rectangle(0, 0, boardW, boardH), Phaser.Geom.Rectangle.Contains);
      boardZone.input.cursor = 'pointer';
      boardZone.on('pointerdown', function () {
        if (selfM.transitioning) return;
        selfM._openMap(fd);
      });
      this.mapZones.push(zone);
    }

    _buildInteractableNPC(npc, idx) {
      var side = npc.position === 'right' ? 'right' : 'left';
      var px = (side === 'left' ? 16 : FLOOR_W - 17) * T;
      var py = (FLOOR_H / 2 + (idx % 2 === 0 ? 2 : -3)) * T;

      var texKey = 'inpc-f' + this.floorNum + '-' + idx;
      var customKey = 'custom-f' + this.floorNum + '-npc-' + idx;
      var sprite;

      if (this.textures.exists(customKey)) {
        sprite = this.physics.add.image(px, py, customKey).setDepth(9);
        sprite.setDisplaySize(T, T * 1.5);
        sprite.body.setImmovable(true);
        this.physics.add.collider(sprite, this.walls);
        // Player CAN bump into interactable NPCs. (Future multiplayer: skip player-vs-other-player.)
        if (this.player) this.physics.add.collider(sprite, this.player);
      } else {
        if (!this.textures.exists(texKey)) {
          var opts = {
            skin: '#f5c6a0',
            shirt: npc.shirtColor || '#ff71ce',
            pants: '#2a1f3d',
            hair: npc.hairColor || '#1a1a2e',
            hairStyle: parseInt(npc.hairStyle || '0')
          };
          this.textures.addCanvas(texKey, VaporSprites.genPlayerSprite(opts));
          registerSpriteFrames(this, texKey);
        }
        sprite = this.physics.add.sprite(px, py, texKey, 0).setDepth(9);
        sprite.setCollideWorldBounds(true);
        sprite.body.setSize(20, 16).setOffset(6, 28);
        sprite.body.setImmovable(true);
        this.physics.add.collider(sprite, this.walls);
        // Player CAN bump into interactable NPCs. (Future multiplayer: skip player-vs-other-player.)
        if (this.player) this.physics.add.collider(sprite, this.player);

        ['down', 'left', 'right', 'up'].forEach(function (dir, row) {
          var ak = texKey + '-walk-' + dir;
          if (!this.anims.exists(ak)) {
            this.anims.create({
              key: ak,
              frames: [
                { key: texKey, frame: row * 4 },
                { key: texKey, frame: row * 4 + 1 },
                { key: texKey, frame: row * 4 },
                { key: texKey, frame: row * 4 + 3 }
              ],
              frameRate: 6, repeat: -1
            });
          }
        }.bind(this));

        var self = this;
        sprite.wanderTimer = this.time.addEvent({
          delay: 3000 + Math.random() * 4000,
          callback: function () { self._npcWander(sprite, texKey); },
          loop: true
        });
      }

      // Name tag — track on sprite so it follows in update()
      var nameCol = npc.shirtColor || '#ff71ce';
      var nameText = (npc.name || 'NPC').substring(0, 14);
      sprite.nameBg = this.add.rectangle(px, py - T * 1.3, T * 2, T * 0.6, 0x1a1a2e, 0.85).setDepth(10);
      sprite.nameText = this.add.text(px, py - T * 1.3, nameText, {
        fontFamily: '"Press Start 2P"', fontSize: '5px', color: nameCol
      }).setOrigin(0.5).setDepth(11);

      // Interaction zone — track on sprite so it follows too
      var zone = this.add.zone(px, py + T * 0.5, T * 2, T * 2);
      this.physics.add.existing(zone, true);
      zone.npcData = npc;
      sprite.interactZone = zone;
      this.interactableNPCs.push(zone);

      // Tap-to-talk: NPCs are wandering targets — make the sprite itself tappable too
      var selfN = this;
      sprite.setInteractive();
      sprite.input.cursor = 'pointer';
      sprite.on('pointerdown', function () {
        if (selfN.transitioning) return;
        selfN._openKiosk(npc);
      });
      zone.setInteractive(new Phaser.Geom.Rectangle(0, 0, T * 2, T * 2), Phaser.Geom.Rectangle.Contains);
      zone.input.cursor = 'pointer';
      zone.on('pointerdown', function () {
        if (selfN.transitioning) return;
        selfN._openKiosk(npc);
      });

      // Track for update loop
      if (!this.npcsWithLabels) this.npcsWithLabels = [];
      this.npcsWithLabels.push(sprite);
    }

    _buildKiosk(kiosk, kpos) {
      var key = 'f' + this.floorNum + '-' + kiosk.position + '-kiosk';
      var pulseColor = kiosk.accentColor || '#01cdfe';
      var pulseHex = parseInt(pulseColor.replace('#', ''), 16) || 0x01cdfe;

      var customKey = 'custom-kiosk-' + key;
      var cx = (kpos.x + kpos.w / 2) * T;
      var cy = (kpos.y + kpos.h / 2) * T;

      var facing = kpos.facing || 'bottom';
      var topY = kpos.y * T + T * 0.3;
      var botY = (kpos.y + kpos.h - 1) * T + T * 0.3;
      var frontY = (facing === 'top') ? topY : botY;
      var backY = (facing === 'top') ? botY : topY;

      if (this.textures.exists(customKey)) {
        var sprite = this.add.image(cx, cy, customKey).setDepth(2);
        if (facing === 'top') sprite.setFlipY(true);
        sprite.setDisplaySize(kpos.w * T, kpos.h * T);
      } else {
        // Procedural kiosk — accents flip based on facing
        this.add.rectangle(cx, cy, kpos.w * T, kpos.h * T, 0x2a1f3d, 0.85).setDepth(2);
        // Roof trim on the BACK side
        this.add.rectangle(cx, backY, kpos.w * T, T * 0.6, pulseHex, 0.6).setDepth(3);
        // Counter front on the FRONT side
        this.add.rectangle(cx, frontY, kpos.w * T - T, T * 0.7, 0x1a1a2e, 0.9).setDepth(3);
        // Pulsing accent dot on the back
        var accent = this.add.circle(cx, backY, 4, pulseHex, 0.9).setDepth(4);
        this.tweens.add({ targets: accent, alpha: { from: 0.5, to: 1 }, duration: 1200, yoyo: true, repeat: -1 });
      }

      // Name tag — above if facing bottom, below if facing top
      if (kiosk.name) {
        var tagY = (facing === 'top')
          ? (kpos.y + kpos.h) * T + T / 2
          : (kpos.y - 1) * T + T / 2;
        this.add.rectangle(cx, tagY, T * 2.5, T * 0.7, 0x1a1a2e, 0.9).setDepth(4);
        this.add.text(cx, tagY, kiosk.name, {
          fontFamily: '"Press Start 2P"', fontSize: '5px', color: pulseColor, align: 'center'
        }).setOrigin(0.5).setDepth(5);
      }

      // Collision
      this._wall(kpos.x * T, kpos.y * T, kpos.w * T, kpos.h * T);

      // Interaction zone — full perimeter + 1 tile margin (like stores). Stored bbox
      // so the update() proximity check can use rectangle containment instead of
      // distance-to-center.
      var zoneBx = (kpos.x - 1) * T;
      var zoneBy = (kpos.y - 1) * T;
      var zoneW = (kpos.w + 2) * T;
      var zoneH = (kpos.h + 2) * T;
      var zoneCx = zoneBx + zoneW / 2;
      var zoneCy = zoneBy + zoneH / 2;
      var zone = this.add.zone(zoneCx, zoneCy, zoneW, zoneH);
      this.physics.add.existing(zone, true);
      zone.kioskData = kiosk;
      zone._bx = zoneBx;
      zone._by = zoneBy;
      zone._bw = zoneW;
      zone._bh = zoneH;
      // Tap-to-open
      zone.setInteractive(new Phaser.Geom.Rectangle(0, 0, zoneW, zoneH), Phaser.Geom.Rectangle.Contains);
      zone.input.cursor = 'pointer';
      var selfK = this;
      zone.on('pointerdown', function () {
        if (selfK.transitioning) return;
        selfK._openKiosk(kiosk);
      });
      this.kioskZones.push(zone);
    }

    _buildEscalator(esc, direction, targetFloor) {
      var texKey = direction === 'up' ? 'escalator-up' : 'escalator-down';
      var img = this.add.image(esc.x * T + T, esc.y * T + T * 1.5, texKey).setDepth(2);
      this.tweens.add({ targets: img, y: img.y + (direction === 'up' ? -3 : 3), duration: 600, yoyo: true, repeat: -1, ease: 'Sine.easeInOut' });

      var targetFloorData = getFloor(targetFloor);
      var targetName = (targetFloorData && targetFloorData.floorName) || ('FLOOR ' + targetFloor);
      var label = targetName.toUpperCase() + (direction === 'up' ? ' ▲' : ' ▼');
      var labelCol = direction === 'up' ? '#05ffa1' : '#01cdfe';
      this.add.rectangle(esc.x * T + T, (esc.y - 1) * T + T / 2, T * 3, T * 0.8, 0x1a1a2e, 0.9).setDepth(3);
      var st = this.add.text(esc.x * T + T, (esc.y - 1) * T + T / 2, label, { fontFamily: '"Press Start 2P"', fontSize: '6px', color: labelCol, align: 'center' }).setOrigin(0.5).setDepth(4);
      this.tweens.add({ targets: st, alpha: { from: 0.7, to: 1 }, duration: 1000, yoyo: true, repeat: -1 });

      var zone = this.add.zone(esc.x * T + T, (esc.y + 1) * T + T, T * 3, T * 3);
      this.physics.add.existing(zone, true);
      zone.escalatorDir = direction;
      zone.targetFloor = targetFloor;
      // Tap-to-use
      var selfE = this;
      zone.setInteractive(new Phaser.Geom.Rectangle(0, 0, T * 3, T * 3), Phaser.Geom.Rectangle.Contains);
      zone.input.cursor = 'pointer';
      zone.on('pointerdown', function () {
        if (selfE.transitioning) return;
        selfE._useEscalator(zone);
      });
      this.escalatorZones.push(zone);
    }

    _setupBasementAtmosphere() {
      var W = FLOOR_W * T, H = FLOOR_H * T;
      var scene = this;

      // --- 1. Vignette / darkness overlay — screen-space, follows camera ---
      // A dark tint over the whole floor lowers ambient brightness
      var tint = this.add.rectangle(0, 0, W, H, 0x000000, 0.45).setOrigin(0, 0).setDepth(50);
      this.tweens.add({
        targets: tint,
        alpha: { from: 0.40, to: 0.55 },
        duration: 4000,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });

      // --- 2. Flickering dim pulse — simulates a broken overhead light ---
      var flicker = this.add.rectangle(0, 0, W, H, 0x000000, 0).setOrigin(0, 0).setDepth(51);
      function scheduleFlicker() {
        scene.time.delayedCall(2500 + Math.random() * 5000, function () {
          // Quick flickering cluster of 3-5 pulses
          var flashes = 3 + Math.floor(Math.random() * 3);
          for (var i = 0; i < flashes; i++) {
            scene.time.delayedCall(i * (40 + Math.random() * 80), function () {
              flicker.setAlpha(0.35 + Math.random() * 0.25);
              scene.time.delayedCall(30 + Math.random() * 60, function () { flicker.setAlpha(0); });
            });
          }
          scheduleFlicker();
        });
      }
      scheduleFlicker();

      // --- 3. Drifting mist / ghostly particles ---
      // Spawn 12 slow-moving soft circles across the floor
      this.basementMist = [];
      for (var m = 0; m < 12; m++) {
        var mx = Math.random() * W;
        var my = Math.random() * H;
        var mist = this.add.circle(mx, my, 14 + Math.random() * 10, 0x3a2a4a, 0.18).setDepth(8);
        mist._vx = (Math.random() - 0.5) * 0.15;
        mist._vy = (Math.random() - 0.5) * 0.1 - 0.05;
        this.basementMist.push(mist);
        this.tweens.add({
          targets: mist,
          alpha: { from: 0.08, to: 0.22 },
          duration: 3000 + Math.random() * 3000,
          yoyo: true,
          repeat: -1,
          ease: 'Sine.easeInOut'
        });
      }

      // --- 4. Red eyes peering from dark corners ---
      // 3 pairs of small red dots that blink slowly at random intervals
      var eyePositions = [
        { x: 3 * T, y: 4 * T },
        { x: (FLOOR_W - 3) * T, y: 4 * T },
        { x: 3 * T, y: (FLOOR_H - 4) * T },
        { x: (FLOOR_W - 3) * T, y: (FLOOR_H - 4) * T }
      ];
      // Pick 3 random corners (not all 4 — unpredictability is creepier)
      eyePositions.sort(function () { return Math.random() - 0.5; });
      var chosen = eyePositions.slice(0, 3);
      chosen.forEach(function (p) {
        var spacing = 3;
        var eye1 = scene.add.rectangle(p.x, p.y, 2, 2, 0xff0020, 0).setDepth(9);
        var eye2 = scene.add.rectangle(p.x + spacing, p.y, 2, 2, 0xff0020, 0).setDepth(9);
        // Subtle glow halos
        var halo1 = scene.add.circle(p.x, p.y, 5, 0xff0040, 0).setDepth(8);
        var halo2 = scene.add.circle(p.x + spacing, p.y, 5, 0xff0040, 0).setDepth(8);
        function schedule() {
          scene.time.delayedCall(4000 + Math.random() * 10000, function () {
            // Fade in, stare for 1-2s, fade out
            scene.tweens.add({ targets: [eye1, eye2], alpha: { from: 0, to: 0.9 }, duration: 300, yoyo: true, hold: 1200 + Math.random() * 1200 });
            scene.tweens.add({ targets: [halo1, halo2], alpha: { from: 0, to: 0.3 }, duration: 300, yoyo: true, hold: 1200 + Math.random() * 1200 });
            // Occasional "blink" mid-stare
            if (Math.random() < 0.5) {
              scene.time.delayedCall(700, function () {
                eye1.setAlpha(0); eye2.setAlpha(0);
                scene.time.delayedCall(80, function () { eye1.setAlpha(0.9); eye2.setAlpha(0.9); });
              });
            }
            schedule();
          });
        }
        schedule();
      });

      // --- 5. Cobwebs in the 4 corners — procedural triangular meshes ---
      function drawCobweb(cornerX, cornerY, orientX, orientY) {
        var size = T * 2.2;
        var g = scene.add.graphics().setDepth(3);
        g.lineStyle(1, 0xc0c0d0, 0.35);
        // Radial spokes from the corner
        var spokeCount = 5;
        for (var s = 0; s < spokeCount; s++) {
          var t = s / (spokeCount - 1);
          var ang = (Math.PI / 2) * t;
          var ex = cornerX + orientX * Math.cos(ang) * size;
          var ey = cornerY + orientY * Math.sin(ang) * size;
          g.lineBetween(cornerX, cornerY, ex, ey);
        }
        // Concentric arcs
        for (var r = 0; r < 3; r++) {
          var rad = (r + 1) * size / 3;
          g.beginPath();
          for (var a = 0; a <= Math.PI / 2; a += 0.15) {
            var px = cornerX + orientX * Math.cos(a) * rad;
            var py = cornerY + orientY * Math.sin(a) * rad;
            if (a === 0) g.moveTo(px, py); else g.lineTo(px, py);
          }
          g.strokePath();
        }
      }
      drawCobweb(T * 0.5, T * 0.5, 1, 1);
      drawCobweb((FLOOR_W - 0.5) * T, T * 0.5, -1, 1);
      drawCobweb(T * 0.5, (FLOOR_H - 0.5) * T, 1, -1);
      drawCobweb((FLOOR_W - 0.5) * T, (FLOOR_H - 0.5) * T, -1, -1);

      // --- 6. Random puddles/stains on the floor ---
      for (var p = 0; p < 8; p++) {
        var px = T * 3 + Math.random() * (W - T * 6);
        var py = T * 4 + Math.random() * (H - T * 8);
        var stain = this.add.ellipse(px, py, 8 + Math.random() * 12, 5 + Math.random() * 6, 0x1a0a14, 0.5).setDepth(1);
      }

      // --- 7. Screen-space vignette via corner darkening (attached to camera) ---
      // Four dark corner rectangles that follow the camera — creates a "flashlight only" feel
      var cam = this.cameras.main;
      var cw = cam.width, ch = cam.height;
      // These will be sized dynamically in update; for initial placement use camera size.
      this.basementVignette = {
        top:    this.add.rectangle(0, 0, cw * 3, ch * 0.25, 0x000000, 0.55).setOrigin(0.5, 1).setScrollFactor(0).setDepth(52),
        bottom: this.add.rectangle(0, ch, cw * 3, ch * 0.25, 0x000000, 0.55).setOrigin(0.5, 0).setScrollFactor(0).setDepth(52),
        left:   this.add.rectangle(0, 0, cw * 0.25, ch * 3, 0x000000, 0.45).setOrigin(1, 0.5).setScrollFactor(0).setDepth(52),
        right:  this.add.rectangle(cw, 0, cw * 0.25, ch * 3, 0x000000, 0.45).setOrigin(0, 0.5).setScrollFactor(0).setDepth(52)
      };
      // Gentle pulse on the vignette to feel like uneasy breathing
      this.tweens.add({
        targets: [this.basementVignette.top, this.basementVignette.bottom, this.basementVignette.left, this.basementVignette.right],
        alpha: { from: 0.50, to: 0.62 },
        duration: 3500,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut'
      });

      // --- 8. Occasional whisper bubble from thin air ---
      var whispers = ['...help...', '...get out...', '...who...', '...down here...', '...cold...', '...behind you...'];
      function scheduleWhisper() {
        scene.time.delayedCall(8000 + Math.random() * 15000, function () {
          if (!scene.player || !scene.player.active) { scheduleWhisper(); return; }
          // Spawn a fake ghost sprite near player (invisible) and emit bubble from it
          var gx = scene.player.x + (Math.random() - 0.5) * T * 8;
          var gy = scene.player.y + (Math.random() - 0.5) * T * 6;
          var ghost = { x: gx, y: gy, active: true };
          showBubble(scene, ghost, whispers[Math.floor(Math.random() * whispers.length)]);
          scheduleWhisper();
        });
      }
      scheduleWhisper();
    }

    _buildStairs(pos, targetFloor) {
      // Decrepit stone staircase — uniform width, weathered, mossy, chipped.
      // Procedurally render as a single texture on a Graphics canvas for crisp pixel look.
      var key = 'stairs-basement';
      if (!this.textures.exists(key)) {
        var sw = pos.w * T;   // uniform width
        var sh = pos.h * T;
        var cv = document.createElement('canvas');
        cv.width = sw; cv.height = sh;
        var ctx = cv.getContext('2d');
        ctx.imageSmoothingEnabled = false;

        // Dark shaft behind the stairs (void above the top step)
        ctx.fillStyle = '#05040a';
        ctx.fillRect(0, 0, sw, sh);

        var stepCount = 7;
        var stepH = Math.floor(sh / stepCount);

        // Seeded pseudo-random for consistent cracks each reload
        var seed = 31415;
        function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }

        for (var i = 0; i < stepCount; i++) {
          var sy = i * stepH;
          // Each step gets a slightly different gray — older/dirtier near the bottom
          var depth = i / (stepCount - 1); // 0 at top (deepest), 1 at bottom (closest)
          var base = 60 + Math.floor(depth * 30);      // 60 → 90
          var hi   = base + 25;
          var lo   = Math.max(20, base - 30);

          // Step tread — full width
          ctx.fillStyle = 'rgb(' + base + ',' + (base - 4) + ',' + (base + 6) + ')';
          ctx.fillRect(0, sy, sw, stepH);

          // Tread stone-tile seams (2-3 vertical cracks per step at random positions)
          var seams = 2 + Math.floor(rnd() * 2);
          for (var s = 0; s < seams; s++) {
            var sx = 3 + Math.floor(rnd() * (sw - 6));
            ctx.fillStyle = 'rgb(' + lo + ',' + (lo - 4) + ',' + (lo + 4) + ')';
            ctx.fillRect(sx, sy + 2, 1, stepH - 3);
          }

          // Highlight: top 1px of each step catches light
          ctx.fillStyle = 'rgb(' + hi + ',' + (hi - 4) + ',' + (hi + 8) + ')';
          ctx.fillRect(1, sy + 1, sw - 2, 1);

          // Riser shadow: bottom 2px of each step is the dark vertical face
          ctx.fillStyle = 'rgb(18,14,26)';
          ctx.fillRect(0, sy + stepH - 2, sw, 2);
          ctx.fillStyle = 'rgb(8,6,14)';
          ctx.fillRect(0, sy + stepH - 1, sw, 1);

          // Chipped corners — erase a few pixels on random edge spots
          var chips = 2 + Math.floor(rnd() * 3);
          for (var ch = 0; ch < chips; ch++) {
            var side = rnd() < 0.5 ? 0 : 1;
            var cx = side === 0 ? Math.floor(rnd() * 4) : sw - 1 - Math.floor(rnd() * 4);
            var cy = sy + 1 + Math.floor(rnd() * (stepH - 3));
            var cw = 1 + Math.floor(rnd() * 2);
            ctx.fillStyle = 'rgb(' + lo + ',' + (lo - 6) + ',' + (lo + 2) + ')';
            ctx.fillRect(cx, cy, cw, 1);
          }

          // Random small cracks (1-2 per step — short dark lines)
          var cracks = 1 + Math.floor(rnd() * 2);
          for (var cr = 0; cr < cracks; cr++) {
            var cx1 = 4 + Math.floor(rnd() * (sw - 10));
            var cy1 = sy + 3 + Math.floor(rnd() * (stepH - 6));
            var clen = 2 + Math.floor(rnd() * 4);
            var cdx = rnd() < 0.5 ? 1 : 0;
            var cdy = rnd() < 0.5 ? 1 : 0;
            ctx.fillStyle = 'rgba(0,0,0,0.6)';
            for (var ck = 0; ck < clen; ck++) {
              ctx.fillRect(cx1 + ck * cdx, cy1 + ck * cdy, 1, 1);
            }
          }

          // Moss patches — small green/teal blotches, more frequent on lower steps (newer growth)
          if (rnd() < 0.45 + depth * 0.35) {
            var mx = 2 + Math.floor(rnd() * (sw - 8));
            var my = sy + 2 + Math.floor(rnd() * (stepH - 5));
            var mw = 2 + Math.floor(rnd() * 3);
            var mh = 1 + Math.floor(rnd() * 2);
            ctx.fillStyle = 'rgba(50, 90, 60, 0.8)';
            ctx.fillRect(mx, my, mw, mh);
            ctx.fillStyle = 'rgba(90, 140, 80, 0.7)';
            ctx.fillRect(mx, my, mw - 1, 1);
          }

          // Dirt / grime — a few brown specks
          var dirt = 1 + Math.floor(rnd() * 3);
          for (var d = 0; d < dirt; d++) {
            ctx.fillStyle = 'rgba(60,40,20,0.5)';
            ctx.fillRect(2 + Math.floor(rnd() * (sw - 4)), sy + 2 + Math.floor(rnd() * (stepH - 4)), 1, 1);
          }
        }

        // Descending shadow gradient — top of the stairs fades to pitch black (suggests the basement darkness)
        for (var gy = 0; gy < Math.floor(stepH * 0.7); gy++) {
          var a = 1 - gy / Math.floor(stepH * 0.7);
          ctx.fillStyle = 'rgba(0,0,0,' + (a * 0.7).toFixed(2) + ')';
          ctx.fillRect(0, gy, sw, 1);
        }

        // Side walls — dark cracked stone pillars flanking the stairs
        function drawWall(xLeft) {
          ctx.fillStyle = '#14101a';
          ctx.fillRect(xLeft, 0, 3, sh);
          ctx.fillStyle = '#26202a';
          ctx.fillRect(xLeft, 0, 1, sh); // inner highlight
          // Random brick seams along the wall
          for (var wy = 4; wy < sh; wy += 6 + Math.floor(rnd() * 4)) {
            ctx.fillStyle = 'rgba(0,0,0,0.7)';
            ctx.fillRect(xLeft, wy, 3, 1);
          }
        }
        drawWall(0);
        drawWall(sw - 3);

        this.textures.addCanvas(key, cv);
      }

      // Place the stairs sprite at the world position
      var cx = (pos.x + pos.w / 2) * T;
      var cy = (pos.y + pos.h / 2) * T;
      var wpx = pos.w * T, hpx = pos.h * T;
      this.add.image(cx, cy, key).setDepth(2).setDisplaySize(wpx, hpx);

      // Dust motes drifting up out of the stairwell
      for (var m = 0; m < 4; m++) {
        var mote = this.add.rectangle(
          cx + (Math.random() - 0.5) * wpx * 0.6,
          (pos.y + pos.h * 0.2) * T,
          1, 1, 0xa0a0c0, 0.7
        ).setDepth(3);
        this.tweens.add({
          targets: mote,
          y: mote.y - 10 - Math.random() * 8,
          alpha: { from: 0.7, to: 0 },
          duration: 2500 + Math.random() * 1500,
          delay: Math.random() * 2000,
          repeat: -1,
          yoyo: false,
          ease: 'Sine.easeOut',
          onRepeat: function (tween, target) {
            target.y = (pos.y + pos.h * 0.7) * T;
            target.alpha = 0.7;
          }
        });
      }

      // Pulsing purple up-arrow floating above the stairs
      var arrow = this.add.text(cx, pos.y * T - 2, '▲', { fontFamily: '"Press Start 2P"', fontSize: '10px', color: '#b967ff' }).setOrigin(0.5, 1).setDepth(4);
      this.tweens.add({ targets: arrow, alpha: { from: 0.5, to: 1 }, y: { from: pos.y * T - 2, to: pos.y * T - 5 }, duration: 900, yoyo: true, repeat: -1, ease: 'Sine.easeInOut' });

      // Sign above the stairs
      var signY = (pos.y - 1) * T + T / 2;
      this.add.rectangle(cx, signY, T * 3, T * 0.8, 0x1a1a2e, 0.9).setDepth(3);
      var targetData = getFloor(targetFloor);
      var targetName = (targetData && targetData.floorName) || ('FLOOR ' + targetFloor);
      var label = targetName.toUpperCase() + ' ▲';
      var st = this.add.text(cx, signY, label, { fontFamily: '"Press Start 2P"', fontSize: '6px', color: '#b967ff', align: 'center' }).setOrigin(0.5).setDepth(4);
      this.tweens.add({ targets: st, alpha: { from: 0.7, to: 1 }, duration: 1000, yoyo: true, repeat: -1 });

      // Interaction zone — below the stairs so player walks up to them
      var zoneWS = pos.w * T + T, zoneHS = T * 3;
      var zone = this.add.zone(cx, (pos.y + pos.h + 1) * T, zoneWS, zoneHS);
      this.physics.add.existing(zone, true);
      zone.escalatorDir = 'up';
      zone.targetFloor = targetFloor;
      // Tap-to-use
      var selfS = this;
      zone.setInteractive(new Phaser.Geom.Rectangle(0, 0, zoneWS, zoneHS), Phaser.Geom.Rectangle.Contains);
      zone.input.cursor = 'pointer';
      zone.on('pointerdown', function () {
        if (selfS.transitioning) return;
        selfS._useEscalator(zone);
      });
      this.escalatorZones.push(zone);
    }

    _buildBasementDoor(pos) {
      var cx = (pos.x + pos.w / 2) * T;
      var cy = (pos.y + pos.h / 2) * T;
      var w = pos.w * T;
      var h = pos.h * T;

      if (this.textures.exists('basement-door')) {
        // Custom uploaded basement door graphic
        var img = this.add.image(cx, cy, 'basement-door').setDepth(2);
        img.setDisplaySize(w, h);
        // Subtle pulsing glow halo behind the image
        var glow = this.add.rectangle(cx, cy, w + 4, h + 4, 0xb967ff, 0.15).setDepth(1);
        this.tweens.add({ targets: glow, alpha: { from: 0.15, to: 0.45 }, duration: 1400, yoyo: true, repeat: -1 });
      } else {
        // Procedural fallback: dark recessed doorway with purple neon frame
        this.add.rectangle(cx, cy, w, h, 0x08041a, 1).setDepth(2);
        this.add.rectangle(cx, cy, w - 4, h - 4, 0x1a0a2e, 1).setDepth(2);
        this.add.rectangle(cx, cy - h / 2 + 1, w - 2, 2, 0xb967ff, 0.9).setDepth(3);
        this.add.rectangle(cx - w / 2 + 1, cy, 2, h - 2, 0xb967ff, 0.6).setDepth(3);
        this.add.rectangle(cx + w / 2 - 1, cy, 2, h - 2, 0xb967ff, 0.6).setDepth(3);
        var glow = this.add.rectangle(cx, cy, w + 4, h + 4, 0xb967ff, 0.15).setDepth(2);
        this.tweens.add({ targets: glow, alpha: { from: 0.15, to: 0.45 }, duration: 1400, yoyo: true, repeat: -1 });
      }
      // Sign above the door (north side since door is in bottom wall)
      var signY = (pos.y - 1) * T + T / 2;
      this.add.rectangle(cx, signY, T * 3, T * 0.8, 0x1a1a2e, 0.9).setDepth(3);
      var bd = getFloor('Basement');
      var label = ((bd && bd.floorName) || 'BASEMENT').toUpperCase() + ' ▼';
      var st = this.add.text(cx, signY, label, { fontFamily: '"Press Start 2P"', fontSize: '6px', color: '#b967ff', align: 'center' }).setOrigin(0.5).setDepth(4);
      this.tweens.add({ targets: st, alpha: { from: 0.7, to: 1 }, duration: 1000, yoyo: true, repeat: -1 });
      // Interaction zone just NORTH of the door (player approaches from above)
      var zoneW2 = w + T, zoneH2 = T * 2;
      var zone = this.add.zone(cx, (pos.y - 0.5) * T, zoneW2, zoneH2);
      this.physics.add.existing(zone, true);
      zone.escalatorDir = 'down';
      zone.targetFloor = 'Basement';
      // Tap-to-use
      var selfBd = this;
      zone.setInteractive(new Phaser.Geom.Rectangle(0, 0, zoneW2, zoneH2), Phaser.Geom.Rectangle.Contains);
      zone.input.cursor = 'pointer';
      zone.on('pointerdown', function () {
        if (selfBd.transitioning) return;
        selfBd._useEscalator(zone);
      });
      this.escalatorZones.push(zone);
    }

    _createPlayer() {
      var texKey = this.textures.exists('player') ? 'player' : 'player-default';
      this.player = this.physics.add.sprite((FLOOR_W / 2) * T, (FLOOR_H / 2 + 8) * T, texKey, 0).setDepth(10);
      this.player.setCollideWorldBounds(true);
      this.player.body.setSize(20, 16).setOffset(6, 28);
      this.physics.world.setBounds(0, 0, FLOOR_W * T, FLOOR_H * T);
      this.physics.add.collider(this.player, this.walls);

      var dirs = ['down', 'left', 'right', 'up'];
      var self = this;
      dirs.forEach(function (dir, row) {
        if (!self.anims.exists('walk-' + dir)) self.anims.create({ key: 'walk-' + dir, frames: [{ key: texKey, frame: row * 4 }, { key: texKey, frame: row * 4 + 1 }, { key: texKey, frame: row * 4 }, { key: texKey, frame: row * 4 + 3 }], frameRate: 8, repeat: -1 });
        if (!self.anims.exists('idle-' + dir)) self.anims.create({ key: 'idle-' + dir, frames: [{ key: texKey, frame: row * 4 }], frameRate: 1 });
      });
      this.playerDir = 'down';
    }

    _setupCamera() {
      this.cameras.main.setBounds(0, 0, FLOOR_W * T, FLOOR_H * T);
      this.cameras.main.startFollow(this.player, true, 0.08, 0.08);
      this.cameras.main.setBackgroundColor(CONFIG.colors.bg);
      var isMobileView = window.matchMedia && window.matchMedia('(max-width: 768px), (orientation: portrait) and (max-width: 900px)').matches;
      var defaultDesktop = 2;
      var saved = parseFloat(localStorage.getItem('vapor-mall-zoom') || '');
      var minZoom = this._computeMinZoom();
      var zoom = isMobileView ? Math.max(0.9, minZoom) : (saved >= 0.6 && saved <= 4 ? Math.max(saved, minZoom) : defaultDesktop);
      this.cameras.main.setZoom(zoom);
      this._setupZoomSlider(isMobileView);
    }

    // Smallest zoom level that still fills the camera viewport with the world
    // (anything lower and we'd see empty background past the world bounds).
    _computeMinZoom() {
      var cam = this.cameras.main;
      var worldW = FLOOR_W * T, worldH = FLOOR_H * T;
      var vw = cam.width || 1, vh = cam.height || 1;
      var min = Math.max(vw / worldW, vh / worldH);
      // Tiny safety margin so we never get a sub-pixel sliver of bg
      return Math.ceil(min * 100) / 100;
    }

    _setupZoomSlider(isMobileView) {
      if (isMobileView) return;
      var slider = document.getElementById('vapor-zoom-slider');
      if (!slider) return;
      var self = this;
      var minZoom = this._computeMinZoom();
      // Replace existing listeners by cloning the node (each scene init re-binds fresh)
      var fresh = slider.cloneNode(true);
      slider.parentNode.replaceChild(fresh, slider);
      fresh.min = String(minZoom);
      // Clamp current value into the new valid range
      var current = Math.max(minZoom, Math.min(parseFloat(fresh.max) || 3.5, this.cameras.main.zoom));
      fresh.value = current;
      this.cameras.main.setZoom(current);
      fresh.addEventListener('input', function () {
        var z = parseFloat(fresh.value);
        if (isNaN(z)) return;
        var lo = self._computeMinZoom();
        if (z < lo) z = lo;
        self.cameras.main.setZoom(z);
        localStorage.setItem('vapor-mall-zoom', String(z));
      });

      // The zoom slider is a native <input type="range">: once clicked it keeps
      // keyboard focus, so arrow keys nudge its value (changing the zoom) instead
      // of moving the player. Hand focus back to the game the moment the user
      // stops dragging, and never let the slider act on arrow keys itself.
      fresh.tabIndex = -1; // don't let Tab land focus on it either
      var releaseFocus = function () { try { fresh.blur(); } catch (e) {} };
      fresh.addEventListener('pointerup', releaseFocus);
      fresh.addEventListener('mouseup', releaseFocus);
      fresh.addEventListener('touchend', releaseFocus);
      fresh.addEventListener('change', releaseFocus);
      fresh.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === 'ArrowUp' || k === 'ArrowDown' || k === 'ArrowLeft' || k === 'ArrowRight' ||
            k === 'PageUp' || k === 'PageDown' || k === 'Home' || k === 'End') {
          // Block the slider's native value change (no zoom nudge) but DON'T
          // stopPropagation — Phaser's window listener still gets the key so the
          // player keeps moving. Then drop focus so subsequent keys skip the slider.
          e.preventDefault();
          fresh.blur();
        }
      });

      // Recompute on window/orientation resize — Phaser ScaleManager fires 'resize'
      var resizeHandler = function () {
        var lo = self._computeMinZoom();
        fresh.min = String(lo);
        if (parseFloat(fresh.value) < lo) {
          fresh.value = lo;
          self.cameras.main.setZoom(lo);
          localStorage.setItem('vapor-mall-zoom', String(lo));
        }
      };
      this.scale.on('resize', resizeHandler);
      // Clean up the listener when the scene shuts down so we don't leak handlers
      this.events.once('shutdown', function () { self.scale.off('resize', resizeHandler); });
    }

    _setupTouchJoystick() {
      var js = document.getElementById('touch-joystick');
      if (!js) return;
      var thumb = js.querySelector('.touch-joystick__thumb');
      if (!thumb) return;

      // No DOM restructuring — CSS handles mobile positioning via fixed + viewport math

      // Shared touch input — normalized -1..1 for x and y
      this.touchInput = { x: 0, y: 0, active: false };
      var self = this;
      var activeTouchId = null;
      var centerX = 0, centerY = 0;
      var maxRadius = 40;

      function updateCenter() {
        var rect = js.getBoundingClientRect();
        centerX = rect.left + rect.width / 2;
        centerY = rect.top + rect.height / 2;
      }

      function onStart(e) {
        if (self.chatFocused) return;
        e.preventDefault();
        var t = e.changedTouches ? e.changedTouches[0] : e;
        activeTouchId = t.identifier != null ? t.identifier : 'mouse';
        updateCenter();
        self.touchInput.active = true;
      }

      function onMove(e) {
        if (!self.touchInput.active) return;
        e.preventDefault();
        var touches = e.changedTouches;
        var t;
        if (touches) {
          for (var i = 0; i < touches.length; i++) {
            if (touches[i].identifier === activeTouchId) { t = touches[i]; break; }
          }
          if (!t) return;
        } else { t = e; }

        var dx = t.clientX - centerX;
        var dy = t.clientY - centerY;
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist > maxRadius) {
          dx = (dx / dist) * maxRadius;
          dy = (dy / dist) * maxRadius;
        }
        thumb.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
        self.touchInput.x = dx / maxRadius;
        self.touchInput.y = dy / maxRadius;
      }

      function onEnd(e) {
        if (!self.touchInput.active) return;
        if (e.changedTouches) {
          var match = false;
          for (var i = 0; i < e.changedTouches.length; i++) {
            if (e.changedTouches[i].identifier === activeTouchId) { match = true; break; }
          }
          if (!match) return;
        }
        self.touchInput.x = 0;
        self.touchInput.y = 0;
        self.touchInput.active = false;
        activeTouchId = null;
        thumb.style.transform = 'translate(0, 0)';
      }

      js.addEventListener('touchstart', onStart, { passive: false });
      js.addEventListener('touchmove', onMove, { passive: false });
      js.addEventListener('touchend', onEnd);
      js.addEventListener('touchcancel', onEnd);
      // Also support mouse for desktop debugging
      js.addEventListener('mousedown', onStart);
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onEnd);
    }

    _setupMultiplayer() {
      var MP = window.Galleria95MP;
      if (!MP || !MP.enabled) return;
      var self = this;
      this.remoteSprites = {};         // id -> Phaser sprite
      this.remoteBubbleEls = {};       // id -> last bubble entry (so we can clear)

      // Floor key — numeric or 'Basement'
      MP.start(String(this.floorNum));

      // Receive chat → spawn a bubble above their sprite (or a floating one if not loaded yet)
      MP.onChat(function (msg) {
        var sprite = self.remoteSprites[msg.id];
        if (sprite) showBubble(self, sprite, (msg.name ? msg.name + ': ' : '') + msg.text);
      });
    }

    _ensureRemoteSprite(id, remote) {
      if (this.remoteSprites[id] && this.remoteSprites[id].active) return this.remoteSprites[id];
      var key = 'remote-' + id;
      if (!this.textures.exists(key)) {
        this.textures.addCanvas(key, VaporSprites.genPlayerSprite(remote.opts || {}));
        registerSpriteFrames(this, key);
      }
      var sprite = this.physics.add.sprite(remote.x || (FLOOR_W / 2) * T, remote.y || (FLOOR_H / 2) * T, key, 0).setDepth(9);
      sprite.body.setSize(20, 16).setOffset(6, 28);
      sprite.body.setImmovable(true);
      // Name tag
      var nameY = -T * 1.3;
      sprite.nameBg = this.add.rectangle(sprite.x, sprite.y + nameY, T * 2.5, T * 0.6, 0x1a1a2e, 0.85).setDepth(10);
      sprite.nameText = this.add.text(sprite.x, sprite.y + nameY, (remote.name || 'Visitor').substring(0, 16), {
        fontFamily: '"Press Start 2P"', fontSize: '5px', color: '#01cdfe', align: 'center'
      }).setOrigin(0.5).setDepth(11);
      // Animations (per-key — Phaser keys must be unique)
      var dirs = ['down', 'left', 'right', 'up'];
      var scene = this;
      dirs.forEach(function (dir, row) {
        var ak = key + '-walk-' + dir;
        if (!scene.anims.exists(ak)) scene.anims.create({ key: ak, frames: [{ key: key, frame: row * 4 }, { key: key, frame: row * 4 + 1 }, { key: key, frame: row * 4 }, { key: key, frame: row * 4 + 3 }], frameRate: 8, repeat: -1 });
        var ik = key + '-idle-' + dir;
        if (!scene.anims.exists(ik)) scene.anims.create({ key: ik, frames: [{ key: key, frame: row * 4 }], frameRate: 1 });
      });
      this.remoteSprites[id] = sprite;
      return sprite;
    }

    _syncRemotes() {
      var MP = window.Galleria95MP;
      if (!MP || !MP.enabled || !this.remoteSprites) return;
      var remotes = MP.getRemotes();
      var seen = {};
      var key, r;
      for (key in remotes) {
        if (!Object.prototype.hasOwnProperty.call(remotes, key)) continue;
        r = remotes[key];
        if (typeof r.x !== 'number') continue;
        seen[key] = true;
        var sprite = this._ensureRemoteSprite(key, r);
        // Smooth position interpolation (lerp toward latest)
        var lerp = 0.25;
        sprite.x += (r.x - sprite.x) * lerp;
        sprite.y += (r.y - sprite.y) * lerp;
        // Animation
        var moving = Math.abs(r.x - sprite.x) > 0.5 || Math.abs(r.y - sprite.y) > 0.5 || r.anim === 'walk';
        var dir = r.dir || 'down';
        var animPrefix = (r.anim === 'walk' || moving) ? 'walk-' : 'idle-';
        var animKey = 'remote-' + key + '-' + animPrefix + dir;
        if (this.anims.exists(animKey)) sprite.anims.play(animKey, true);
        // Sync name tag
        var nameY = -T * 1.3;
        if (sprite.nameBg) sprite.nameBg.setPosition(sprite.x, sprite.y + nameY);
        if (sprite.nameText) sprite.nameText.setPosition(sprite.x, sprite.y + nameY);
        sprite.setDepth(sprite.y);
      }
      // Clean up sprites for players who left
      var existing = Object.keys(this.remoteSprites);
      for (var i = 0; i < existing.length; i++) {
        var id = existing[i];
        if (!seen[id]) {
          var s = this.remoteSprites[id];
          if (s) {
            if (s.nameBg) s.nameBg.destroy();
            if (s.nameText) s.nameText.destroy();
            s.destroy();
          }
          delete this.remoteSprites[id];
        }
      }
    }

    _broadcastMyPosition() {
      var MP = window.Galleria95MP;
      if (!MP || !MP.enabled || !this.player) return;
      var moving = Math.abs(this.player.body.velocity.x) > 1 || Math.abs(this.player.body.velocity.y) > 1;
      MP.sendPosition(this.player.x, this.player.y, this.playerDir || 'down', moving ? 'walk' : 'idle');
    }

    _setupChat() {
      if (!CONFIG.enableChat) return;
      var chatInput = document.getElementById('chat-input');
      var chatSend = document.getElementById('chat-send');
      var self = this;
      var send = function () {
        var msg = chatInput.value.trim();
        if (!msg) return;
        chatInput.value = '';
        chatInput.blur();
        showBubble(self, self.player, msg);
        // Broadcast to other players (no-op stub if multiplayer disabled)
        if (window.Galleria95MP && window.Galleria95MP.enabled) {
          window.Galleria95MP.sendChat(msg);
        }
      };
      if (chatSend) chatSend.onclick = send;
      if (chatInput) {
        chatInput.onkeydown = function (e) {
          if (e.key === 'Enter') { e.preventDefault(); send(); }
          e.stopPropagation();
        };
      }
    }

    _setupNPCs() {
      this.npcs = [];
      var npcDefs = [
        { skin: '#f5c6a0', shirt: '#01cdfe', hair: '#1a1a2e', hairStyle: 0 },
        { skin: '#c68642', shirt: '#b967ff', hair: '#4a3728', hairStyle: 1 },
        { skin: '#8d5524', shirt: '#05ffa1', hair: '#1a1a2e', hairStyle: 2 },
        { skin: '#f9dcc4', shirt: '#fffb96', hair: '#c0392b', hairStyle: 0 },
        { skin: '#e0ac84', shirt: '#ff71ce', hair: '#d4a030', hairStyle: 1 }
      ];
      var positions = [[16 * T, 18 * T], [FLOOR_W * T - 16 * T, 18 * T], [20 * T, FLOOR_H * T - 12 * T], [FLOOR_W * T - 20 * T, FLOOR_H * T - 12 * T], [(FLOOR_W / 2) * T, 18 * T]];
      var self = this;

      npcDefs.forEach(function (opts, i) {
        var k = 'npc-' + self.floorNum + '-' + i;
        if (!self.textures.exists(k)) { self.textures.addCanvas(k, VaporSprites.genPlayerSprite(opts)); registerSpriteFrames(self, k); }
        var npc = self.physics.add.sprite(positions[i][0], positions[i][1], k, 0).setDepth(9);
        npc.setCollideWorldBounds(true); npc.body.setSize(20, 16).setOffset(6, 28);
        self.physics.add.collider(npc, self.walls);
        // Player CAN bump into NPCs. (Future multiplayer: skip player-vs-other-player colliders.)
        self.physics.add.collider(npc, self.player);
        ['down', 'left', 'right', 'up'].forEach(function (dir, row) {
          var ak = k + '-walk-' + dir;
          if (!self.anims.exists(ak)) self.anims.create({ key: ak, frames: [{ key: k, frame: row * 4 }, { key: k, frame: row * 4 + 1 }, { key: k, frame: row * 4 }, { key: k, frame: row * 4 + 3 }], frameRate: 6, repeat: -1 });
        });
        npc.wanderTimer = self.time.addEvent({ delay: 2000 + Math.random() * 3000, callback: function () { self._npcWander(npc, k); }, loop: true });
        self.time.addEvent({ delay: 8000 + Math.random() * 15000, callback: function () {
          var phraseStr = (CONFIG.npcPhrases || '').trim();
          var phrases = phraseStr
            ? phraseStr.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; })
            : ['nice place!', 'love this mall', 'cool shirt!', 'vibes', 'rad'];
          showBubble(self, npc, phrases[Math.floor(Math.random() * phrases.length)]);
        }, loop: true });
        self.npcs.push(npc);
      });
    }

    _npcWander(npc, k) {
      var acts = ['idle', 'idle', 'up', 'down', 'left', 'right'];
      var a = acts[Math.floor(Math.random() * acts.length)];
      npc.body.setVelocity(0, 0);
      if (a === 'idle') return;
      var sp = 40;
      var map = { up: [0, -sp], down: [0, sp], left: [-sp, 0], right: [sp, 0] };
      npc.body.setVelocity(map[a][0], map[a][1]);
      npc.play(k + '-walk-' + a, true);
      this.time.delayedCall(500 + Math.random() * 1500, function () { if (npc.active) { npc.body.setVelocity(0, 0); npc.anims.stop(); } });
    }

    // Create a DOM <img> overlay for the center element (supports APNG animation)
    _createCenterOverlay(imgUrl, worldX, worldY, worldW, worldH) {
      // Body-level fixed-position element — most stable across theme layouts.
      // Earlier attempt to parent inside #vapor-mall-game with overflow:hidden
      // triggered Phaser ScaleManager resize loops on certain layouts.
      var img = document.getElementById('vapor-center-overlay');
      if (!img) {
        img = document.createElement('img');
        img.id = 'vapor-center-overlay';
        img.style.cssText = 'position:fixed; pointer-events:none; z-index:5; image-rendering:pixelated; image-rendering:crisp-edges; transform-origin:top left; will-change:transform; transition:opacity 0.4s;';
        document.body.appendChild(img);
      }
      img.src = imgUrl;
      img.style.opacity = '0';
      img.onload = function () { img.style.opacity = '1'; };
      img._worldX = worldX;
      img._worldY = worldY;
      img._worldW = worldW;
      img._worldH = worldH;
      return img;
    }

    _syncCenterOverlay() {
      var img = this._centerElementOverlay;
      if (!img || !img.isConnected) return;
      var cam = this.cameras.main;
      var pt = cam.getWorldPoint(0, 0);
      var wx = img._worldX - img._worldW / 2;
      var wy = img._worldY - img._worldH / 2;
      var sx = (wx - pt.x) * cam.zoom;
      var sy = (wy - pt.y) * cam.zoom;
      var sw = img._worldW * cam.zoom;
      var sh = img._worldH * cam.zoom;

      var gameDiv = document.getElementById('vapor-mall-game');
      var rect = gameDiv ? gameDiv.getBoundingClientRect() : { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };

      img.style.left = (rect.left + sx) + 'px';
      img.style.top = (rect.top + sy) + 'px';
      img.style.width = sw + 'px';
      img.style.height = sh + 'px';

      // Hide entirely if the overlay would clip outside the game viewport
      // (prevents leaking into the mobile top/bottom frames)
      var clipsOut = (sx + sw < 0) || (sx > rect.width) || (sy + sh < 0) || (sy > rect.height);
      img.style.display = clipsOut ? 'none' : '';

      // Hide if completely off screen (within game view)
      var gameW = rect.width || window.innerWidth;
      var gameH = rect.height || window.innerHeight;
      var visible = sx + sw > 0 && sx < gameW && sy + sh > 0 && sy < gameH;
      img.style.display = visible ? 'block' : 'none';
    }

    // Called right after initFloor on scene entry; data may request opening a specific section
    _handleArrivalData(data) {
      if (!data || !data.openSection) return;
      var fd = getFloor(this.floorNum);
      if (!fd) return;
      var section = (fd.stores || []).find(function (s) { return s.position === data.openSection; });
      if (!section) return;
      var self = this;
      // Wait for fade-in to finish before opening the overlay
      this.cameras.main.once('camerafadeincomplete', function () {
        if (data.textOnlyMsg) {
          showBubble(self, self.player, 'Visit the location!');
        } else {
          self._openSection(section);
        }
      });
    }

    _updateHUD() {
      var el = document.getElementById('hud-floor');
      if (el) {
        var name = (this.floorData && this.floorData.floorName) || ('FLOOR ' + this.floorNum);
        el.textContent = name.toUpperCase();
        el.className = 'hud__floor hud__floor--' + this.floorNum;
      }
    }

    _useEscalator(dir) {
      if (this.transitioning) return;
      if (this.interactPrompt) this.interactPrompt.classList.remove('interact-prompt--visible');
      this.transitioning = true;
      this.player.body.setVelocity(0, 0);
      var target = dir.targetFloor;
      var self = this;
      // Leave the multiplayer channel for the floor we're departing
      if (window.Galleria95MP && window.Galleria95MP.enabled) window.Galleria95MP.stop();
      this.cameras.main.fadeOut(600, 26, 26, 46);
      this.cameras.main.once('camerafadeoutcomplete', function () {
        clearBubbles();
        var oldOverlay = document.getElementById('vapor-center-overlay');
        if (oldOverlay && oldOverlay.parentNode) oldOverlay.parentNode.removeChild(oldOverlay);
        self.scene.start('MallFloor' + target);
      });
    }

    // Called from the map card click — teleports/opens the selected section.
    _teleportToSection(targetFloor, section) {
      var self = this;
      // Close the map modal first
      var modal = document.getElementById('vapor-kiosk-modal');
      if (modal) modal.classList.add('kiosk-modal--hidden');
      this.scene.resume();

      var sct = section.contentType;
      if (sct === 'interactable') sct = section.displayType === 'page' ? 'interactable_page' : 'interactable_text';
      var isText = sct === 'interactable_text';

      // If on a different floor, switch floors first
      if (targetFloor !== this.floorNum) {
        this.transitioning = true;
        this.player.body.setVelocity(0, 0);
        if (window.Galleria95MP && window.Galleria95MP.enabled) window.Galleria95MP.stop();
        this.cameras.main.fadeOut(400, 26, 26, 46);
        this.cameras.main.once('camerafadeoutcomplete', function () {
          clearBubbles();
          var oldOverlay = document.getElementById('vapor-center-overlay');
          if (oldOverlay && oldOverlay.parentNode) oldOverlay.parentNode.removeChild(oldOverlay);
          self.scene.start('MallFloor' + targetFloor, { openSection: section.position, textOnlyMsg: isText });
        });
        return;
      }

      // Same floor — for text-only sections, just surface the "Visit the location!" hint.
      // For stores or page-type interactables, open their overlay directly.
      if (isText) {
        showBubble(self, self.player, 'Visit the location!');
      } else {
        self._openSection(section);
      }
    }

    _openMap(mapData) {
      if (this.interactPrompt) this.interactPrompt.classList.remove('interact-prompt--visible');
      var self = this;
      var visibleFloors = (CONFIG.floors || []).filter(function (f) { return f.visible !== false && typeof f.floor === 'number'; });
      var currentFloor = mapData.floor;

      function renderMapHTML(floorData) {
        var positions = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
        var storesByPos = {};
        (floorData.stores || []).forEach(function (s) { storesByPos[s.position] = s; });

        // Floor tabs
        var html = '<div style="display:flex; gap:8px; margin-bottom:18px; flex-wrap:wrap;">';
        visibleFloors.forEach(function (f) {
          var active = f.floor === floorData.floor;
          var label = (f.floorName || 'FLOOR ' + f.floor).toUpperCase();
          html += '<button class="map-floor-tab" data-floor="' + f.floor + '" ' +
            'style="background:' + (active ? '#ff71ce' : 'rgba(26,26,46,0.8)') + ';' +
            'color:' + (active ? '#1a1a2e' : '#01cdfe') + ';' +
            'border:1px solid rgba(255,113,206,0.4); padding:8px 14px; font-family:\'Press Start 2P\'; ' +
            'font-size:0.5rem; cursor:pointer; letter-spacing:1px;">' + label + '</button>';
        });
        html += '</div>';

        // 2x2 visual store grid — each card clickable to teleport into that section
        html += '<div style="display:grid; grid-template-columns: 1fr 1fr; gap: 20px;">';
        positions.forEach(function (pos) {
          var s = storesByPos[pos];
          var color = s ? (s.signPulseColor || '#ff71ce') : '#333';
          var name = s ? (s.name || 'STORE') : 'EMPTY';
          var hint = '';
          if (s) {
            var sct = s.contentType;
            if (sct === 'interactable') sct = s.displayType === 'page' ? 'interactable_page' : 'interactable_text';
            if (sct === 'interactable_page') hint = 'READ PAGE';
            else if (sct === 'interactable_text') hint = 'VIEW';
            else hint = 'VISIT SHOP';
          }
          var clickAttr = s ? ' data-section-floor="' + floorData.floor + '" data-section-pos="' + pos + '" class="map-section-card"' : '';
          var cursor = s ? 'cursor:pointer;' : 'cursor:default; opacity:0.5;';
          html += '<div' + clickAttr + ' style="border:1px solid ' + color + '; padding:14px; background:rgba(10,10,22,0.65); display:flex; flex-direction:column; align-items:center; gap:10px; ' + cursor + ' transition:filter 0.15s, box-shadow 0.15s;">';
          html += '<div style="width:20px; height:20px; background:' + color + '; box-shadow:0 0 12px ' + color + ';"></div>';
          html += '<div style="font-size:0.55rem; color:' + color + '; letter-spacing:1px; text-align:center;">' + name + '</div>';
          if (hint) {
            html += '<div style="font-size:0.4rem; color:rgba(255,255,255,0.5); letter-spacing:2px;">▸ ' + hint + '</div>';
          }
          html += '</div>';
        });
        html += '</div>';

        return html;
      }

      function showFloor(floorNumber) {
        var fd = (CONFIG.floors || []).find(function (f) { return f.floor === floorNumber; });
        if (!fd) return;
        currentFloor = floorNumber;
        var body = document.getElementById('kiosk-modal-body');
        var title = document.getElementById('kiosk-modal-title');
        title.textContent = 'MAP — ' + (fd.floorName || 'FLOOR ' + fd.floor).toUpperCase();
        body.innerHTML = renderMapHTML(fd);
        body.querySelectorAll('.map-floor-tab').forEach(function (btn) {
          btn.addEventListener('click', function () {
            showFloor(parseInt(btn.dataset.floor));
          });
        });
        // Wire up section card clicks — teleport to section
        body.querySelectorAll('.map-section-card').forEach(function (card) {
          var originalBorder = card.style.borderColor;
          card.addEventListener('mouseenter', function () {
            card.style.boxShadow = 'inset 0 0 24px rgba(255,255,255,0.08), 0 0 16px rgba(255,113,206,0.35)';
            card.style.filter = 'brightness(1.25)';
          });
          card.addEventListener('mouseleave', function () {
            card.style.boxShadow = '';
            card.style.filter = '';
          });
          card.addEventListener('click', function () {
            var targetFloor = parseInt(card.dataset.sectionFloor);
            var targetPos = card.dataset.sectionPos;
            var targetFd = (CONFIG.floors || []).find(function (f) { return f.floor === targetFloor; });
            if (!targetFd) return;
            var section = (targetFd.stores || []).find(function (s) { return s.position === targetPos; });
            if (!section) return;
            self._teleportToSection(targetFloor, section);
          });
        });
      }

      // Use existing kiosk modal infrastructure
      this.player.body.setVelocity(0, 0);
      this.scene.pause();

      var modal = document.getElementById('vapor-kiosk-modal');
      var closeBtn = document.getElementById('kiosk-modal-close');
      var inner = modal.querySelector('.kiosk-modal__inner');

      // Apply theme-level map window bg if set.
      // Quote the URL (Shopify CDN URLs can contain chars that break bare url()),
      // and neutralize the overlay blend-mode + dark fill so the image actually reads through.
      var winBg = (CONFIG.map && CONFIG.map.windowBgImage) || '';
      if (winBg) {
        inner.style.backgroundImage = 'url("' + winBg + '")';
        inner.style.backgroundColor = 'transparent';
        inner.style.backgroundBlendMode = 'normal';
      } else {
        inner.style.backgroundImage = '';
        inner.style.backgroundColor = '';
        inner.style.backgroundBlendMode = '';
      }

      showFloor(currentFloor);
      modal.classList.remove('kiosk-modal--hidden');

      var close = function () {
        modal.classList.add('kiosk-modal--hidden');
        self.scene.resume();
        closeBtn.removeEventListener('click', close);
        document.removeEventListener('keydown', keyClose);
      };
      var keyClose = function (e) {
        if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); close(); }
      };
      closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', keyClose);
    }

    _openKiosk(kiosk) {
      // Shoppable kiosk — route to the shop overlay instead of the text modal
      if (kiosk && (kiosk.contentType === 'store' || kiosk.contentType === 'single_product')) {
        this._openShop({
          name: kiosk.name || 'KIOSK',
          handle: kiosk.contentType === 'store' ? (kiosk.handle || '') : '',
          products: kiosk.products || [],
          bgImage: kiosk.textBgImage || '',
          bgPreset: kiosk.bgPreset || 'roman-grotto'
        });
        return;
      }
      if (this.interactPrompt) this.interactPrompt.classList.remove('interact-prompt--visible');
      this.player.body.setVelocity(0, 0);
      this.scene.pause();
      var modal = document.getElementById('vapor-kiosk-modal');
      var title = document.getElementById('kiosk-modal-title');
      var body = document.getElementById('kiosk-modal-body');
      var closeBtn = document.getElementById('kiosk-modal-close');
      var inner = modal.querySelector('.kiosk-modal__inner');

      title.textContent = kiosk.name || 'KIOSK';
      body.innerHTML = kiosk.textContent || '<p>...</p>';

      // Apply custom text window bg if provided — quote URL and neutralize blend-mode/fill
      if (kiosk.textBgImage) {
        inner.style.backgroundImage = 'url("' + kiosk.textBgImage + '")';
        inner.style.backgroundColor = 'transparent';
        inner.style.backgroundBlendMode = 'normal';
      } else {
        inner.style.backgroundImage = '';
        inner.style.backgroundColor = '';
        inner.style.backgroundBlendMode = '';
      }

      modal.classList.remove('kiosk-modal--hidden');

      var self = this;
      var close = function () {
        modal.classList.add('kiosk-modal--hidden');
        self.scene.resume();
        closeBtn.removeEventListener('click', close);
        document.removeEventListener('keydown', keyClose);
      };
      var keyClose = function (e) {
        if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); close(); }
      };
      closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', keyClose);
    }

    // Router — called when player interacts with a section block.
    // contentType: 'store' | 'interactable_page' | 'interactable_text' (legacy 'interactable' still handled)
    _openSection(section) {
      if (this.interactPrompt) this.interactPrompt.classList.remove('interact-prompt--visible');
      var ct = section.contentType;
      // Legacy fallback: older data used "interactable" + displayType
      if (ct === 'interactable') {
        ct = section.displayType === 'page' ? 'interactable_page' : 'interactable_text';
      }
      if (ct === 'interactable_page') {
        this._openPageOverlay(section);
      } else if (ct === 'interactable_text') {
        this._openKiosk({
          name: section.name || 'INTERACT',
          textContent: section.interactableText || '<p>...</p>',
          textBgImage: section.bgImage || ''
        });
      } else {
        this._openShop(section);
      }
    }

    // Opens a Shopify page in the same overlay as shops, with custom bg support
    _openPageOverlay(section) {
      if (this.interactPrompt) this.interactPrompt.classList.remove('interact-prompt--visible');
      this.player.body.setVelocity(0, 0);
      this.scene.pause();
      var overlay = document.getElementById('vapor-shop-overlay');
      var title = document.getElementById('shop-overlay-title');
      var productsEl = document.getElementById('shop-overlay-products');
      var closeBtn = document.getElementById('shop-overlay-close');
      var self = this;

      console.log('VAPOR MALL — _openPageOverlay section:', section);

      title.textContent = section.pageTitle || section.name || 'PAGE';

      if (section.bgImage) {
        overlay.style.backgroundImage = 'url(' + section.bgImage + ')';
      } else {
        var preset = section.bgPreset || 'roman-grotto';
        if (!window._bgCache) window._bgCache = {};
        if (!window._bgCache[preset]) { window._bgCache[preset] = VaporSprites.genShopBackground(preset, 1200, 800).toDataURL(); }
        overlay.style.backgroundImage = 'url(' + window._bgCache[preset] + ')';
      }
      overlay.style.backgroundSize = 'cover';
      overlay.style.backgroundPosition = 'center';

      productsEl.innerHTML = '';
      productsEl.style.display = 'block';
      var pageEl = document.createElement('div');
      pageEl.style.cssText = 'background:rgba(10,10,22,0.6); padding:24px; border:1px solid var(--vapor-border); color:var(--vapor-text); font-size:0.55rem; line-height:2; letter-spacing:0.5px;';

      if (section.pageHandle) {
        pageEl.innerHTML = '';
        pageEl.style.padding = '0';
        pageEl.style.background = 'transparent';
        pageEl.style.border = 'none';
        var iframe = document.createElement('iframe');
        var src = '/pages/' + section.pageHandle + '?view=bare';
        if (section.pageBgImage) src += '&bg=' + encodeURIComponent(section.pageBgImage);
        iframe.src = src;
        iframe.title = section.pageTitle || section.name || 'Page';
        iframe.style.cssText = 'width:100%; height:62vh; min-height:400px; border:1px solid var(--vapor-border); background:rgba(10,10,22,0.85); display:block;';
        pageEl.appendChild(iframe);
      } else if (section.pageContent && section.pageContent.trim().length > 0) {
        // Fallback: inline render if we somehow have content but no handle
        pageEl.innerHTML = section.pageContent;
      } else {
        pageEl.innerHTML = '<p style="color:var(--vapor-cyan);">No page selected for this Interactable — Page section.</p>';
      }
      productsEl.appendChild(pageEl);

      overlay.classList.remove('shop-overlay--hidden');
      closeBtn.onclick = function () {
        overlay.classList.add('shop-overlay--hidden');
        productsEl.style.display = '';
        self.scene.resume();
      };
    }

    _openShop(store) {
      this.player.body.setVelocity(0, 0);
      this.scene.pause();
      var overlay = document.getElementById('vapor-shop-overlay');
      var title = document.getElementById('shop-overlay-title');
      var productsEl = document.getElementById('shop-overlay-products');
      var closeBtn = document.getElementById('shop-overlay-close');

      title.textContent = store.name || 'SHOP';
      productsEl.style.display = '';
      productsEl.classList.remove('shop-overlay__products--detail');
      productsEl.innerHTML = '<p style="color:var(--vapor-cyan);font-size:0.5rem;padding:20px;">Loading...</p>';

      // Background
      if (store.bgImage) {
        overlay.style.backgroundImage = 'url(' + store.bgImage + ')';
      } else {
        var preset = store.bgPreset || 'roman-grotto';
        if (!window._bgCache) window._bgCache = {};
        if (!window._bgCache[preset]) { window._bgCache[preset] = VaporSprites.genShopBackground(preset, 1200, 800).toDataURL(); }
        overlay.style.backgroundImage = 'url(' + window._bgCache[preset] + ')';
      }
      overlay.style.backgroundSize = 'cover';
      overlay.style.backgroundPosition = 'center';

      var products = store.products || [];
      var self = this;
      var singleProductMode = !store.handle && products.length === 1;

      var state = {
        handle: store.handle,
        page: 1,
        loading: false,
        done: false,
        hasInitial: products.length > 0
      };
      var onScroll = null;

      var openDetail = function (p) {
        if (onScroll) productsEl.removeEventListener('scroll', onScroll);
        self._renderProductDetail(productsEl, p, singleProductMode ? null : renderGrid);
      };

      var renderGrid = function () {
        productsEl.classList.remove('shop-overlay__products--detail');
        productsEl.innerHTML = '';

        if (state.hasInitial) {
          self._appendProducts(productsEl, products, null, openDetail);
          if (products.length < 20) state.done = true;
          else state.page = 2;
        }
        if (!state.hasInitial && state.handle) {
          self._loadMoreProducts(productsEl, state, openDetail);
        }

        var loadMoreEl = document.createElement('div');
        loadMoreEl.id = 'shop-load-more';
        loadMoreEl.style.cssText = 'grid-column: 1 / -1; text-align:center; padding:20px; font-size:0.5rem; color:var(--vapor-cyan); letter-spacing:2px;';
        loadMoreEl.textContent = state.done ? '' : '↓ SCROLL FOR MORE';
        productsEl.appendChild(loadMoreEl);

        onScroll = function () {
          if (state.loading || state.done || !state.handle) return;
          var rect = loadMoreEl.getBoundingClientRect();
          if (rect.top < window.innerHeight + 200) {
            self._loadMoreProducts(productsEl, state, openDetail);
          }
        };
        productsEl.addEventListener('scroll', onScroll);
        setTimeout(onScroll, 50);
      };

      overlay.classList.remove('shop-overlay--hidden');

      if (singleProductMode) {
        openDetail(products[0]);
      } else {
        renderGrid();
      }

      // Arrow-key scroll — up/down scrolls the product list/detail, Esc closes
      var onKey = function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); productsEl.scrollBy({ top: 120, behavior: 'smooth' }); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); productsEl.scrollBy({ top: -120, behavior: 'smooth' }); }
        else if (e.key === 'PageDown') { e.preventDefault(); productsEl.scrollBy({ top: productsEl.clientHeight * 0.9, behavior: 'smooth' }); }
        else if (e.key === 'PageUp') { e.preventDefault(); productsEl.scrollBy({ top: -productsEl.clientHeight * 0.9, behavior: 'smooth' }); }
        else if (e.key === 'Escape') { e.preventDefault(); closeBtn.click(); }
      };
      document.addEventListener('keydown', onKey);

      closeBtn.onclick = function () {
        overlay.classList.add('shop-overlay--hidden');
        productsEl.classList.remove('shop-overlay__products--detail');
        if (onScroll) productsEl.removeEventListener('scroll', onScroll);
        document.removeEventListener('keydown', onKey);
        self.scene.resume();
      };
    }

    // Render a single-product detail view inside productsEl. If onBack is provided,
    // a BACK button restores the parent grid; otherwise the overlay close button is the exit.
    _renderProductDetail(container, p, onBack) {
      container.classList.add('shop-overlay__products--detail');
      container.innerHTML = '<p style="color:var(--vapor-cyan);font-size:0.5rem;padding:20px;text-align:center;">Loading product...</p>';
      container.scrollTop = 0;

      var self = this;
      var handle = p && p.handle;

      var render = function (full) {
        var img = (full && (full.featured_image || (full.images && full.images[0]))) || p.image || '';
        if (img && typeof img === 'object') img = img.src || '';
        var title = (full && full.title) || p.title || '';
        var descHtml = (full && (full.description || full.body_html)) || '';
        var variants = (full && full.variants) || p.variants || [];
        var avail = full ? (full.available !== false) : (p.available !== false);
        var v0f = (full && full.variants && full.variants[0]) || (p.variants && p.variants[0]) || {};
        var raw = (full && full.price_min != null && full.price_min > 0) ? full.price_min
                : (full && full.price != null && full.price > 0) ? full.price
                : (v0f.price != null) ? v0f.price
                : p.price;
        var priceStr = p.priceFormatted || _formatPrice(raw);

        var detail = document.createElement('div');
        detail.className = 'product-detail';
        var backHtml = onBack ? '<button class="product-detail__back" data-back>← BACK TO SHOP</button>' : '';
        var variantHtml = '';
        if (variants.length > 1) {
          variantHtml = '<select class="product-detail__variants">';
          variants.forEach(function (v) {
            var vp = v.priceFormatted || (typeof v.price === 'number' && v.price > 1000
              ? '$' + (v.price / 100).toFixed(2)
              : '$' + (v.price != null ? v.price : ''));
            variantHtml += '<option value="' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>' +
              (v.title || '') + ' — ' + vp + (v.available === false ? ' (SOLD OUT)' : '') + '</option>';
          });
          variantHtml += '</select>';
        }
        detail.innerHTML =
          backHtml +
          (img ? '<div class="product-detail__image-wrap"><img class="product-detail__image" src="' + img + '" alt=""></div>' : '') +
          '<div class="product-detail__title">' + title + '</div>' +
          '<div class="product-detail__price">' + priceStr + '</div>' +
          (descHtml ? '<div class="product-detail__description">' + descHtml + '</div>' : '') +
          variantHtml +
          '<button class="product-detail__cart"' + (avail ? '' : ' disabled') + '>' +
          (avail ? 'ADD TO CART' : 'SOLD OUT') + '</button>';

        container.innerHTML = '';
        container.appendChild(detail);

        var backBtn = detail.querySelector('[data-back]');
        if (backBtn) backBtn.onclick = function () { if (onBack) onBack(); };

        if (avail) {
          var sel = detail.querySelector('.product-detail__variants');
          var cartBtn = detail.querySelector('.product-detail__cart');
          cartBtn.onclick = function () {
            var vid = sel ? parseInt(sel.value) : (variants.length > 0 ? variants[0].id : (full && full.id) || p.id);
            cartBtn.textContent = 'ADDING...'; cartBtn.disabled = true;
            fetch(CONFIG.routes.cartAdd, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
            })
              .then(function (r) { return r.json(); })
              .then(function () {
                cartBtn.textContent = 'ADDED ✓';
                cartBtn.style.background = 'linear-gradient(90deg,#05ffa1,#01cdfe)';
                updateCartCount();
                _openVaporCartSuppressNative();
                setTimeout(function () { cartBtn.textContent = 'ADD TO CART'; cartBtn.style.background = ''; cartBtn.disabled = false; }, 2000);
              })
              .catch(function () {
                cartBtn.textContent = 'ERROR';
                setTimeout(function () { cartBtn.textContent = 'ADD TO CART'; cartBtn.disabled = false; }, 2000);
              });
          };
        }
      };

      // If we already have a description, render immediately. Otherwise fetch it.
      if (p && (p.description || p.body_html)) {
        render(p);
      } else if (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (full) { render(full || p); })
          .catch(function () { render(p); });
      } else {
        render(p);
      }
    }

    _loadMoreProducts(container, state, onCardClick) {
      if (state.loading || state.done || !state.handle) return;
      state.loading = true;
      var self = this;
      var loadMoreEl = container.querySelector('#shop-load-more');
      if (loadMoreEl) loadMoreEl.textContent = 'LOADING...';

      fetch('/collections/' + state.handle + '/products.json?page=' + state.page + '&limit=20')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.products || [];
          if (products.length === 0) {
            state.done = true;
            if (loadMoreEl) loadMoreEl.textContent = state.page === 1 ? '' : '— END OF COLLECTION —';
            if (state.page === 1 && container.children.length <= 1) {
              container.innerHTML = '<p style="color:var(--vapor-cyan);font-size:0.5rem;padding:20px;">This shop is empty...</p>';
            }
          } else {
            self._appendProducts(container, products, loadMoreEl, onCardClick);
            state.page++;
            if (products.length < 20) {
              state.done = true;
              if (loadMoreEl) loadMoreEl.textContent = '— END OF COLLECTION —';
            } else {
              if (loadMoreEl) loadMoreEl.textContent = '↓ SCROLL FOR MORE';
            }
          }
          state.loading = false;
        })
        .catch(function () {
          state.loading = false;
          if (loadMoreEl) loadMoreEl.textContent = '— LOAD FAILED —';
        });
    }

    // Append products to container (keeps the load-more sentinel at the end if present)
    _appendProducts(container, products, sentinelEl, onCardClick) {
      var self = this;
      products.forEach(function (p) {
        var card = self._buildProductCard(p, onCardClick);
        if (sentinelEl && sentinelEl.parentNode === container) {
          container.insertBefore(card, sentinelEl);
        } else {
          container.appendChild(card);
        }
      });
    }

    _buildProductCard(p, onCardClick) {
      var card = document.createElement('div'); card.className = 'product-card';
      var img = p.image || (p.images && p.images[0] && p.images[0].src) || '';
      var v0 = (p.variants && p.variants[0]) || {};
      var raw = (p.price != null) ? p.price : v0.price;
      var price = p.priceFormatted || _formatPrice(raw);
      var variants = p.variants || [];
      var avail = p.available !== false;
      var html = '';
      if (img) html += '<img src="' + img + '" alt="' + (p.title || '') + '">';
      html += '<span class="product-card__title">' + (p.title || '') + '</span>';
      html += '<span class="product-card__price">' + price + '</span>';
      if (variants.length > 1) {
        html += '<select class="product-card__variants">';
        variants.forEach(function (v) {
          html += '<option value="' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>' + v.title + (v.available === false ? ' (SOLD OUT)' : '') + '</option>';
        });
        html += '</select>';
      }
      html += '<button class="product-card__btn"' + (avail ? '' : ' disabled') + '>' + (avail ? 'ADD TO CART' : 'SOLD OUT') + '</button>';
      card.innerHTML = html;
      if (avail) {
        var btn = card.querySelector('.product-card__btn');
        var sel = card.querySelector('.product-card__variants');
        btn.onclick = function () {
          var vid = sel ? parseInt(sel.value) : (variants.length > 0 ? variants[0].id : p.id);
          btn.textContent = 'ADDING...'; btn.disabled = true;
          fetch(CONFIG.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
            .then(function (r) { return r.json(); })
            .then(function () { btn.textContent = 'ADDED ✓'; btn.style.background = 'linear-gradient(90deg,#05ffa1,#01cdfe)'; updateCartCount(); _openVaporCartSuppressNative(); setTimeout(function () { btn.textContent = 'ADD TO CART'; btn.style.background = ''; btn.disabled = false; }, 2000); })
            .catch(function () { btn.textContent = 'ERROR'; setTimeout(function () { btn.textContent = 'ADD TO CART'; btn.disabled = false; }, 2000); });
        };
      }
      if (typeof onCardClick === 'function') {
        card.addEventListener('click', function (e) {
          // Don't hijack clicks on the add-to-cart button or variant select
          if (e.target.closest('.product-card__btn') || e.target.closest('.product-card__variants')) return;
          onCardClick(p);
        });
      }
      return card;
    }

    _renderProducts(container, products) {
      container.innerHTML = '';
      if (!products.length) { container.innerHTML = '<p style="color:var(--vapor-cyan);font-size:0.5rem;">Coming soon...</p>'; return; }
      var self = this;
      products.forEach(function (p) { container.appendChild(self._buildProductCard(p)); });
    }

    update() {
      if (this.chatFocused || this.transitioning) {
        this.player.body.setVelocity(0, 0);
        this.player.anims.play('idle-' + this.playerDir, true);
        updateBubbles(); return;
      }

      var vx = 0, vy = 0;
      if (this.cursors.left.isDown || this.wasd.A.isDown) vx = -this.playerSpeed;
      else if (this.cursors.right.isDown || this.wasd.D.isDown) vx = this.playerSpeed;
      if (this.cursors.up.isDown || this.wasd.W.isDown) vy = -this.playerSpeed;
      else if (this.cursors.down.isDown || this.wasd.S.isDown) vy = this.playerSpeed;
      if (vx !== 0 && vy !== 0) { vx *= 0.707; vy *= 0.707; }

      // Touch joystick overrides keyboard when active
      if (this.touchInput && this.touchInput.active) {
        var tx = this.touchInput.x, ty = this.touchInput.y;
        var mag = Math.sqrt(tx * tx + ty * ty);
        if (mag > 0.15) {
          vx = tx * this.playerSpeed;
          vy = ty * this.playerSpeed;
        }
      }

      this.player.body.setVelocity(vx, vy);

      // Pick facing by the dominant axis. On mobile the joystick almost never
      // reads exact 0 on either axis, so a naive "if vx !== 0" check always
      // wins horizontal and the avatar can never face up/down.
      if (vx === 0 && vy === 0) {
        this.player.anims.play('idle-' + this.playerDir, true);
      } else if (Math.abs(vx) > Math.abs(vy)) {
        if (vx < 0) { this.playerDir = 'left';  this.player.anims.play('walk-left',  true); }
        else        { this.playerDir = 'right'; this.player.anims.play('walk-right', true); }
      } else {
        if (vy < 0) { this.playerDir = 'up';    this.player.anims.play('walk-up',    true); }
        else        { this.playerDir = 'down';  this.player.anims.play('walk-down',  true); }
      }

      // Proximity checks
      this.nearShop = null;
      this.nearEscalator = null;
      this.nearKiosk = null;
      this.nearNPC = null;
      this.nearMap = null;
      var px = this.player.x, py = this.player.y;

      this.shopZones.forEach(function (z) {
        // Rectangle containment — player triggers when standing anywhere
        // inside the store footprint + 1-tile margin (set in _buildShop)
        if (px >= z._bx && px <= z._bx + z._bw && py >= z._by && py <= z._by + z._bh) {
          this.nearShop = z.storeData;
        }
      }.bind(this));

      this.escalatorZones.forEach(function (z) {
        if (Phaser.Math.Distance.Between(px, py, z.x, z.y) < T * 2) this.nearEscalator = z;
      }.bind(this));

      (this.kioskZones || []).forEach(function (z) {
        // Full-perimeter rectangle containment (footprint + 1-tile margin)
        if (z._bx != null && px >= z._bx && px <= z._bx + z._bw && py >= z._by && py <= z._by + z._bh) {
          this.nearKiosk = z.kioskData;
        }
      }.bind(this));

      (this.interactableNPCs || []).forEach(function (z) {
        if (Phaser.Math.Distance.Between(px, py, z.x, z.y) < T * 2) this.nearNPC = z.npcData;
      }.bind(this));

      (this.mapZones || []).forEach(function (z) {
        if (Phaser.Math.Distance.Between(px, py, z.x, z.y) < T * 2.5) this.nearMap = z.mapData;
      }.bind(this));

      // Helper: render two label variants — CSS shows desktop OR mobile per viewport
      var setPromptDualText = function (el, desktopText, mobileText) {
        el.innerHTML =
          '<span class="interact-prompt__desktop"></span>' +
          '<span class="interact-prompt__mobile"></span>';
        el.firstChild.textContent = desktopText;
        el.lastChild.textContent = mobileText;
      };

      if (this.nearShop) {
        var ct = this.nearShop.contentType;
        if (ct === 'interactable') ct = this.nearShop.displayType === 'page' ? 'interactable_page' : 'interactable_text';
        var isInteract = (ct === 'interactable_page' || ct === 'interactable_text');
        setPromptDualText(this.interactPrompt,
          isInteract ? 'PRESS ENTER TO INTERACT' : 'PRESS ENTER TO SHOP',
          isInteract ? 'PRESS HERE TO INTERACT' : 'PRESS HERE TO ENTER');
        this.interactPrompt.classList.add('interact-prompt--visible');
      }
      else if (this.nearKiosk) {
        var kname = this.nearKiosk.name ? this.nearKiosk.name.toUpperCase() : 'KIOSK';
        setPromptDualText(this.interactPrompt, 'PRESS ENTER — ' + kname, 'PRESS HERE — ' + kname);
        this.interactPrompt.classList.add('interact-prompt--visible');
      }
      else if (this.nearNPC) {
        var nname = this.nearNPC.name ? this.nearNPC.name.toUpperCase() : 'NPC';
        setPromptDualText(this.interactPrompt, 'PRESS ENTER — ' + nname, 'PRESS HERE — ' + nname);
        this.interactPrompt.classList.add('interact-prompt--visible');
      }
      else if (this.nearMap) {
        setPromptDualText(this.interactPrompt, 'PRESS ENTER — READ THE MAP', 'PRESS HERE — READ THE MAP');
        this.interactPrompt.classList.add('interact-prompt--visible');
      }
      else if (this.nearEscalator) {
        var tfd = getFloor(this.nearEscalator.targetFloor);
        var tname = (tfd && tfd.floorName) || ('FLOOR ' + this.nearEscalator.targetFloor);
        setPromptDualText(this.interactPrompt, 'PRESS ENTER — ' + tname.toUpperCase(), 'PRESS HERE — ' + tname.toUpperCase());
        this.interactPrompt.classList.add('interact-prompt--visible');
      }
      else { this.interactPrompt.classList.remove('interact-prompt--visible'); }

      this.player.setDepth(this.player.y);
      this.npcs.forEach(function (n) { n.setDepth(n.y); });

      // Sync animated center element overlay with camera
      this._syncCenterOverlay();

      // Multiplayer — broadcast our pos + interpolate remote players
      this._broadcastMyPosition();
      this._syncRemotes();

      // Drift basement mist particles
      if (this.basementMist) {
        var wBound = FLOOR_W * T, hBound = FLOOR_H * T;
        this.basementMist.forEach(function (m) {
          m.x += m._vx;
          m.y += m._vy;
          if (m.x < 0) m.x = wBound;
          if (m.x > wBound) m.x = 0;
          if (m.y < 0) m.y = hBound;
          if (m.y > hBound) m.y = 0;
        });
      }

      // Sync interactable NPC name tags + zones with their moving sprites
      (this.npcsWithLabels || []).forEach(function (s) {
        if (!s.active) return;
        if (s.nameBg) s.nameBg.setPosition(s.x, s.y - T * 1.3);
        if (s.nameText) s.nameText.setPosition(s.x, s.y - T * 1.3);
        if (s.interactZone) {
          s.interactZone.x = s.x;
          s.interactZone.y = s.y + T * 0.5;
          if (s.interactZone.body) s.interactZone.body.reset(s.x, s.y + T * 0.5);
        }
        s.setDepth(s.y);
      });

      updateBubbles();
    }
  }

  // ============================================
  // 3 FLOOR SCENES
  // ============================================
  class MallFloor1 extends MallFloorBase { constructor() { super('MallFloor1'); } create(data) { this.initFloor(1); this._handleArrivalData(data); } }
  class MallFloor2 extends MallFloorBase { constructor() { super('MallFloor2'); } create(data) { this.initFloor(2); this._handleArrivalData(data); } }
  class MallFloor3 extends MallFloorBase { constructor() { super('MallFloor3'); } create(data) { this.initFloor(3); this._handleArrivalData(data); } }
  class MallFloor4 extends MallFloorBase { constructor() { super('MallFloor4'); } create(data) { this.initFloor(4); this._handleArrivalData(data); } }
  class MallFloor5 extends MallFloorBase { constructor() { super('MallFloor5'); } create(data) { this.initFloor(5); this._handleArrivalData(data); } }
  class MallFloorBasement extends MallFloorBase { constructor() { super('MallFloorBasement'); } create(data) { this.initFloor('Basement'); this._handleArrivalData(data); } }

  // ============================================
  // LAUNCH
  // ============================================
  window.game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'vapor-mall-game',
    width: 800, height: 600,
    pixelArt: true,
    physics: { default: 'arcade', arcade: { gravity: { y: 0 }, debug: false } },
    scene: [BootScene, AvatarCreateScene, MallFloor1, MallFloor2, MallFloor3, MallFloor4, MallFloor5, MallFloorBasement],
    scale: { mode: Phaser.Scale.RESIZE, autoCenter: Phaser.Scale.CENTER_BOTH },
    backgroundColor: '#1a1a2e'
  });

  // ---- Keyboard focus guard ----
  // Phaser's createCursorKeys() adds capture for arrows/space/shift, which calls
  // preventDefault at document level — that blocks typing space or uppercase
  // (shift+letter) in any <input> or <textarea>. Turn Phaser's keyboard off
  // while the user is focused on an editable field; turn it back on when they leave.
  function _isEditable(el) {
    if (!el) return false;
    if (el.matches && el.matches('input, textarea, [contenteditable=""], [contenteditable="true"]')) return true;
    return false;
  }
  document.addEventListener('focusin', function (e) {
    if (!_isEditable(e.target)) return;
    if (window.game && window.game.input && window.game.input.keyboard) {
      window.game.input.keyboard.enabled = false;
    }
  });
  document.addEventListener('focusout', function (e) {
    if (!_isEditable(e.target)) return;
    // Defer slightly — if focus is moving to another input, we want to stay off
    setTimeout(function () {
      var ae = document.activeElement;
      if (_isEditable(ae)) return;
      if (window.game && window.game.input && window.game.input.keyboard) {
        window.game.input.keyboard.enabled = true;
      }
    }, 0);
  });

  // ---- HUD tap-through guard ----
  // Stop pointerdown/touchstart from leaking through HUD icons into the Phaser canvas
  // (which has setInteractive shop zones behind the cart/avatar/mute/zoom positions).
  function _armHudTapGuard() {
    // Include the entire cart drawer so clicks on any part of it (incl. checkout button, discount input, remove button) don't leak through to Phaser world objects underneath
    var ids = ['hud-cart-btn', 'hud-avatar-btn', 'hud-mute-btn', 'vapor-zoom-control', 'vapor-zoom-slider', 'vapor-cart-drawer', 'vapor-chat', 'chat-input', 'chat-send'];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el._mmTapGuard) return;
      el._mmTapGuard = true;
      // Only stop the events Phaser actually listens for (pointerdown / touchstart).
      // Do NOT include 'click' here — stopping click can mask bubble-phase app handlers.
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
        el.addEventListener(ev, function (e) { e.stopPropagation(); }, true);
      });
    });
  }
  if (document.readyState === 'complete') _armHudTapGuard();
  else window.addEventListener('load', _armHudTapGuard);

  // Cart — MegaCart (app embed) is the cart on this page; the mall's own drawer
  // is retired. The HUD cart button opens MegaCart, and the old drawer is hidden.
  document.getElementById('hud-cart-btn')?.addEventListener('click', function (e) { e.stopPropagation(); if (window.__v95openDrawer) window.__v95openDrawer(); });
  (function () { var _oldCart = document.getElementById('vapor-cart-drawer'); if (_oldCart) _oldCart.style.display = 'none'; })();

  // Logo → open the map (quick navigation). Also self-guards against tap-through
  // so clicking the logo over a store doesn't walk you into that store.
  (function () {
    var logo = document.querySelector('.hud__mall-name');
    if (!logo || logo._mmLogoWired) return;
    logo._mmLogoWired = true;
    logo.style.cursor = 'pointer';
    logo.setAttribute('title', 'Open map');
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
      logo.addEventListener(ev, function (e) { e.stopPropagation(); }, true);
    });
    logo.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!window.game || !window.game.scene) return;
      var scenes = window.game.scene.getScenes(true); // active scene(s)
      for (var i = 0; i < scenes.length; i++) {
        var s = scenes[i];
        if (s && typeof s._openMap === 'function' && s.floorData && !s.transitioning) {
          s._openMap(s.floorData);
          return;
        }
      }
    });
  })();

  // ---- Avatar customize button in HUD ----
  function renderHudAvatar() {
    var canvas = document.getElementById('hud-avatar-preview');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.imageSmoothingEnabled = false;
    var saved = localStorage.getItem('vapor-mall-avatar');
    var opts = saved ? JSON.parse(saved) : {};
    var sprite = VaporSprites.genPlayerSprite(opts);
    // Draw the "down" facing frame cropped to the head+body area
    ctx.drawImage(sprite, 0, 0, VaporSprites.SPRITE_W * 2, VaporSprites.SPRITE_H * 2, 0, 0, canvas.width, canvas.height);
  }

  // Re-render button on load
  if (document.readyState === 'complete') renderHudAvatar();
  else window.addEventListener('load', renderHudAvatar);

  // Open avatar creator on click — hijacks existing overlay with a one-shot save handler
  document.getElementById('hud-avatar-btn')?.addEventListener('click', function () {
    var overlay = document.getElementById('vapor-avatar-creator');
    var confirmBtn = document.getElementById('avatar-confirm');
    if (!overlay || !confirmBtn) return;

    // Pre-populate with saved avatar
    var saved = localStorage.getItem('vapor-mall-avatar');
    var opts = saved ? JSON.parse(saved) : { skin: '#f5c6a0', shirt: '#ff71ce', pants: '#2a1f3d', hair: '#1a1a2e', hairStyle: 0 };

    // Rebuild pickers targeting these opts
    function renderPreview() {
      var previewCanvas = document.getElementById('avatar-preview');
      var pctx = previewCanvas.getContext('2d');
      pctx.clearRect(0, 0, 128, 128);
      pctx.imageSmoothingEnabled = false;
      var sp = VaporSprites.genPlayerSprite(opts);
      pctx.drawImage(sp, 0, 0, VaporSprites.SPRITE_W * 2, VaporSprites.SPRITE_H * 2, 16, 8, 96, 112);
    }
    function buildPicker(id, colors, prop) {
      var c = document.getElementById(id); c.innerHTML = '';
      colors.forEach(function (col) {
        var s = document.createElement('div');
        s.className = 'color-swatch' + (opts[prop] === col ? ' color-swatch--active' : '');
        s.style.background = col;
        s.onclick = function () {
          opts[prop] = col;
          c.querySelectorAll('.color-swatch').forEach(function (x) { x.classList.remove('color-swatch--active'); });
          s.classList.add('color-swatch--active');
          renderPreview();
        };
        c.appendChild(s);
      });
    }
    function buildStyles() {
      var c = document.getElementById('avatar-hair-styles'); c.innerHTML = '';
      ['SHORT', 'LONG', 'SPIKY', 'BALD'].forEach(function (n, i) {
        var b = document.createElement('button');
        b.className = 'style-btn' + (opts.hairStyle === i ? ' style-btn--active' : '');
        b.textContent = n;
        b.onclick = function () {
          opts.hairStyle = i;
          c.querySelectorAll('.style-btn').forEach(function (x) { x.classList.remove('style-btn--active'); });
          b.classList.add('style-btn--active');
          renderPreview();
        };
        c.appendChild(b);
      });
    }

    buildPicker('avatar-skin-colors', getAvatarPalette('skin'), 'skin');
    buildPicker('avatar-shirt-colors', getAvatarPalette('shirt'), 'shirt');
    buildPicker('avatar-hair-colors', getAvatarPalette('hair'), 'hair');
    buildStyles();
    renderPreview();

    confirmBtn.textContent = 'SAVE & CONTINUE';
    overlay.classList.remove('avatar-creator--hidden');

    // Override confirm handler — save and reload to ensure clean state
    confirmBtn.onclick = function () {
      localStorage.setItem('vapor-mall-avatar', JSON.stringify(opts));
      overlay.classList.add('avatar-creator--hidden');
      // Full reload applies the new avatar to all sprites/animations reliably
      window.location.reload();
    };
  });
})();

